import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const en = {
  nav: {
    students: 'Students',
    departments: 'Departments',
    map: 'Map',
    parents: 'Parents',
    drivers: 'Drivers',
    teachers: 'Teachers',
    routes: 'Routes',
    food: 'Food',
    attendance: 'Daily Register',
    reports: 'Reports',
    messages: 'Messages',
    driver_map: 'Map',
    driver_settings: 'Settings',
    parent_today: 'Today',
    parent_bus_tracking: 'Track Bus',
    parent_menu: 'Menu',
    parent_messages: 'Messages',
    parent_children: 'Children',
    parent_stats: 'Statistics',
    parent_settings: 'Settings',
  },
  header: {
    signed_in_as: 'Signed in as',
    logout: 'Logout',
    preferences: 'Preferences',
    help: 'Help',
    donate: 'Keep the bus running ☕',
    enable_notifications: 'Enable Notifications',
    notifications_on: 'Notifications On',
  },
  preferences: {
    title: 'Preferences',
    subtitle: 'Manage your account details and password',
    personal_info: 'Personal Information',
    first_name: 'First Name',
    last_name: 'Last Name',
    email: 'Email',
    phone_number: 'Mobile Number',
    save: 'Save Changes',
    saved: 'Changes saved successfully',
    save_error: 'Failed to save changes',
    change_password: 'Change Password',
    new_password: 'New Password',
    confirm_password: 'Confirm Password',
    update_password: 'Update Password',
    password_saved: 'Password updated successfully',
    password_mismatch: 'Passwords do not match',
    notifications: 'Notification Preferences',
    notifications_subtitle: 'Choose which push notifications you receive',
    notify_route_start: 'Route started',
    notify_route_start_desc: 'When a driver starts a route',
    notify_route_end: 'Route ended',
    notify_route_end_desc: 'When a driver finishes a route',
    notify_pickup: 'Child picked up / delivered',
    notify_pickup_desc: 'When a child is picked up or dropped off by the bus',
    notify_skip: 'Child skipped at stop',
    notify_skip_desc: 'When a driver skips a child at their stop',
    notify_delay: 'Delay / early arrival',
    notify_delay_desc: 'When the driver reports a delay or early arrival',
    notify_saved: 'Notification preferences saved',
  },
  login: {
    welcome_back: 'Welcome back',
    subtitle: 'Sign in to your SB2 dashboard',
    username: 'Email',
    password: 'Password',
    enter_username: 'Enter your email',
    enter_password: 'Enter your password',
    forgot_password: 'Forgot password?',
    sign_in: 'Sign in',
    signing_in: 'Signing in…',
    tagline_line1: 'Every child,',
    tagline_line2: 'every route,',
    tagline_accented: 'safely home.',
    description: 'Manage students, drivers, routes, and attendance. Communicate with parents, track buses in real time, and handle daily operations — all from one place.',
    active_routes: 'Active Routes',
    students_stat: 'Students',
    on_time: 'On Time',
    footer_note: 'Authorized personnel only. Contact your administrator for access.',
    error_user_not_found: 'No account found with this email.',
    error_wrong_password: 'Incorrect password. Please try again.',
    error_connection: 'Unable to connect. Please check your network and try again.',
    error_unknown: 'Something went wrong. Please try again.',
    error_too_many_requests: 'Too many attempts. Please wait a moment and try again.',
    fp_title: 'Reset your password',
    fp_subtitle: 'Enter your email address and we\'ll send you a 6-digit code.',
    fp_email_label: 'Email Address',
    fp_email_placeholder: 'Enter your email',
    fp_send_code: 'Send Code',
    fp_sending: 'Sending…',
    fp_code_sent: 'A 6-digit code was sent to your email.',
    fp_code_label: 'Verification Code',
    fp_code_placeholder: 'Enter 6-digit code',
    fp_verify_code: 'Verify Code',
    fp_verifying: 'Verifying…',
    fp_new_password_label: 'New Password',
    fp_new_password_placeholder: 'At least 6 characters',
    fp_confirm_password_label: 'Confirm Password',
    fp_confirm_password_placeholder: 'Repeat your new password',
    fp_save_password: 'Set New Password',
    fp_saving: 'Saving…',
    fp_back_to_login: 'Back to login',
    fp_back: 'Back',
    fp_success: 'Your password has been reset. You can now sign in.',
    fp_error_invalid_code: 'Invalid or expired code. Please try again.',
    fp_error_password_mismatch: 'Passwords do not match.',
    fp_error_password_short: 'Password must be at least 6 characters.',
    fp_error_send: 'Failed to send the code. Please try again.',
    fp_error_email_not_found: 'No account is associated with this email address.',
    fp_resend: 'Resend code',
    register_link: 'New user? Register',
    parent_app_android: 'Parent app for Android',
    parent_app_google_play: 'Get it on Google Play',
    reg_title: 'Create Account',
    reg_choose_role: 'I am a...',
    reg_role_parent: 'Parent',
    reg_role_parent_desc: 'Register to track your child\'s bus',
    reg_role_driver: 'Driver',
    reg_role_driver_desc: 'Your school must create your account first',
    reg_role_teacher: 'Teacher',
    reg_role_teacher_desc: 'Your school must create your account first',
    reg_teacher_email_title: 'Teacher Registration',
    reg_teacher_email_subtitle: 'Enter the email address your school used to create your teacher account.',
    reg_teacher_no_account: 'No teacher account found with this email. Contact your school to set up your account first.',
    reg_teacher_already_active: 'This account is already active. Please sign in.',
    reg_back: 'Back',
    reg_next: 'Next',
    reg_submit: 'Register',
    reg_driver_email_title: 'Driver Registration',
    reg_driver_email_subtitle: 'Enter the email address your school used to create your account.',
    reg_driver_email_label: 'Email Address',
    reg_driver_email_placeholder: 'Enter your email',
    reg_driver_no_account: 'No driver account found with this email. Contact your school to set up your account first.',
    reg_driver_already_active: 'This account is already active. Please sign in.',
    reg_code_title: 'Enter Verification Code',
    reg_code_subtitle: 'A 6-digit code was sent to your email.',
    reg_code_label: 'Verification Code',
    reg_code_placeholder: 'Enter 6-digit code',
    reg_code_verify: 'Verify',
    reg_resend: 'Resend code',
    reg_resend_limit: 'Resend limit reached.',
    reg_parent_info_title: 'Parent Registration',
    reg_parent_first_name: 'First Name',
    reg_parent_last_name: 'Last Name',
    reg_parent_email: 'Email Address',
    reg_parent_first_name_placeholder: 'Enter your first name',
    reg_parent_last_name_placeholder: 'Enter your last name',
    reg_parent_email_placeholder: 'Enter your email',
    reg_password_title: 'Set Your Password',
    reg_new_password: 'Password',
    reg_new_password_placeholder: 'At least 6 characters',
    reg_confirm_password: 'Confirm Password',
    reg_confirm_password_placeholder: 'Repeat your password',
    reg_set_password: 'Set Password',
    reg_done_title: 'Account Created!',
    reg_done_subtitle: 'Your account is ready. You can now sign in.',
    reg_back_to_login: 'Back to login',
    reg_error_invalid_code: 'Invalid or expired code. Please try again.',
    reg_error_password_mismatch: 'Passwords do not match.',
    reg_error_password_short: 'Password must be at least 6 characters.',
    reg_error_send: 'Something went wrong. Please try again.',
    reg_agree_terms: 'I agree to the',
    reg_terms_link: 'Terms & Conditions',
    reg_and: 'and',
    reg_privacy_link: 'Privacy Policy',
    reg_must_agree: 'You must accept the Terms & Conditions and Privacy Policy to continue.',
  },
  cookie: {
    message: 'We use cookies and local storage to keep you signed in and remember your preferences.',
    privacy_link: 'Privacy Policy',
    accept: 'Accept',
  },
  students: {
    title: 'Students',
    subtitle: 'Manage enrolled students and their details',
    add: 'Add Student',
    add_title: 'Add New Student',
    edit_title: 'Edit Student',
    loading: 'Loading students…',
    search: 'Search students…',
    first_name: 'First Name',
    surname: 'Surname',
    last_name: 'Last Name',
    school_class: 'School Class',
    department: 'Department',
    school_bus: 'School Bus',
    parents_col: 'Parents',
    actions: 'Actions',
    edit: 'Edit student',
    send_message: 'Send message',
    delete: 'Delete student',
    delete_confirm: 'Are you sure you want to delete the student?',
    bus_to: 'Bus to school',
    bus_from: 'Bus from school',
    personal_info: 'Personal Information',
    school_info: 'School Information',
    transportation: 'Transportation',
    parents_guardians: 'Parents / Guardians',
    go_to_edit_parent: 'Go to edit parent',
    add_new_parent: 'New Parent',
    create_parent_title: 'Create New Parent',
    addresses: 'Pickup / Drop-off Addresses',
    add_address: 'Add Address',
    updated: 'Student updated successfully!',
    created: 'Student created successfully!',
    failed_to_save: 'Failed to save student. Please try again.',
    save_changes: 'Save Changes',
    first_name_required: 'First name is required',
    surname_required: 'Surname is required',
    school_class_required: 'School class is required',
    department_required: 'Department is required',
    dob_required: 'Date of birth is required',
    date_of_birth: 'Date of Birth',
    dob_day: 'Day',
    dob_month: 'Month',
    dob_year: 'Year',
    comments: 'Comments',
    comments_placeholder: 'Any notes about this child…',
    address_label: 'Address',
    address_hint: 'Filled automatically when searching or clicking the map',
    search_address: 'Search for an address…',
    address_comments: 'Comments',
    month_jan: 'January', month_feb: 'February', month_mar: 'March',
    month_apr: 'April', month_may: 'May', month_jun: 'June',
    month_jul: 'July', month_aug: 'August', month_sep: 'September',
    month_oct: 'October', month_nov: 'November', month_dec: 'December',
    show_inactive: 'Show inactive',
    route_assigned_to: 'To School: {{name}}',
    route_assigned_from: 'From School: {{name}}',
    route_not_assigned: 'No route assigned',
    filter_needs_route: 'Needs route',
    filter_has_route: 'Has route',
  },
  drivers: {
    title: 'Drivers',
    subtitle: 'Manage bus drivers and their details',
    add: 'Add Driver',
    loading: 'Loading drivers…',
    search: 'Search drivers…',
    actions: 'Actions',
    edit: 'Edit driver',
    delete: 'Delete driver',
    delete_confirm: 'Are you sure you want to delete the driver?',
    add_title: 'Add Driver',
    edit_title: 'Edit Driver',
    failed_to_load: 'Failed to load driver data.',
    not_found: 'Driver not found.',
    failed_to_save: 'Failed to save driver.',
    activated: 'Activated',
    activatedYes: 'Active',
    activatedNo: 'Pending',
    show_inactive: 'Show inactive',
  },
  teachers: {
    title: 'Teachers',
    subtitle: 'Manage school teachers and their details',
    add: 'Add Teacher',
    loading: 'Loading teachers…',
    search: 'Search teachers…',
    actions: 'Actions',
    edit: 'Edit teacher',
    delete: 'Delete teacher',
    delete_confirm: 'Are you sure you want to delete the teacher?',
    add_title: 'Add Teacher',
    edit_title: 'Edit Teacher',
    failed_to_load: 'Failed to load teacher data.',
    not_found: 'Teacher not found.',
    failed_to_save: 'Failed to save teacher.',
    show_inactive: 'Show inactive',
  },
  parents: {
    title: 'Parents',
    no_children: 'No children',
    search: 'Search parents…',
    add: 'Add Parent',
    filter_by_class: 'Filter by Class',
    filter_by_dept: 'Filter by Department',
    all_classes: 'All classes',
    all_departments: 'All departments',
    send_message: 'Send Message ({{count}})',
    subject: 'Subject',
    message: 'Message',
    sending: 'Sending…',
    send: 'Send',
    send_to: 'Send Message to {{count}} parent',
    send_to_plural: 'Send Message to {{count}} parents',
    of_parents: '{{count}} of {{total}} parents',
    add_title: 'Add Parent',
    edit_title: 'Edit Parent',
    search_address: 'Search for an address…',
    address: 'Address',
    address_optional: '(optional)',
    remove_address: 'Remove address',
    address_hint: 'Filled automatically when you search or click the map — or type manually',
    notes_placeholder: 'Any notes about this parent…',
    notes: 'Notes',
    assign_children: 'Assign Children',
    search_children: 'Search children…',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving…',
    email_required: 'Email is required.',
    email_invalid: 'Please enter a valid email address.',
    failed_to_save: 'Failed to save parent.',
    created: 'Parent created successfully.',
    updated: 'Parent updated successfully.',
    email_exists: 'A parent with this email already exists.',
    email_exists_deleted: 'A parent with this email was previously deleted from this school. You can restore them instead of creating a new one.',
    restore_action: 'Restore',
    restoring: 'Restoring…',
    restored: '{{name}} restored.',
    first_name: 'First Name',
    last_name: 'Last Name',
    email: 'Email *',
    phone: 'Phone Number',
    children_col: 'Children',
    phone_col: 'Phone',
    status_active: 'Registered',
    status_inactive: 'Inactive',
    status_deleted: 'Deleted',
    show_no_children: 'Show without children',
    show_inactive: 'Show inactive',
    show_deleted: 'Show deleted',
    confirm_delete: 'Delete {{name}} from this school?',
    delete_action: 'Delete',
    deleting: 'Deleting…',
    deleted: '{{name}} deleted.',
    duplicate_warning: 'Duplicate: {{name}} ({{email}}) has {{count}} profiles.',
    merge: 'Merge',
    merge_title: 'Merge Duplicate Profiles',
    merge_description: 'Select which profile to keep. The other profile will be deleted and its data (children, phone number) will be merged into the kept profile.',
    merge_keep_label: 'Keep this profile:',
    merge_confirm: 'Merge',
  },
  departments: {
    title: 'Classes & Departments',
    loading: 'Loading departments…',
    new_class: 'New Class',
    no_classes: 'No classes yet',
    no_classes_hint: 'Create your first class to get started',
    no_depts: 'No departments yet',
    add_dept: 'Add department',
    delete_dept: 'Delete department',
    delete_class: 'Delete class',
    rename: 'Rename',
    drop_here: 'Drop students here',
    release_to_drop: 'Release to drop',
    create: 'Create',
    new_class_placeholder: 'e.g. Grade 3',
    new_dept_title: 'New Department',
    new_dept_placeholder: 'e.g. Morning Group',
    delete_class_title: 'Delete Class',
    delete_dept_title: 'Delete Department',
    delete_confirm: 'Are you sure you want to delete "{{name}}"? This cannot be undone.',
    reassign_title: 'Delete Department "{{name}}"',
    reassign_students: 'This department has {{count}} student. Select a department to move them to before deleting.',
    reassign_students_plural: 'This department has {{count}} students. Select a department to move them to before deleting.',
    no_other_depts: 'No other departments available. Please create another department first.',
    move_to: 'Move students to',
    move_and_delete: 'Move & Delete',
    n_classes: '{{count}} class',
    n_classes_plural: '{{count}} classes',
    n_students: '{{count}} student',
    n_students_plural: '{{count}} students',
    n_depts: '{{count}} dept',
    n_depts_plural: '{{count}} depts',
    drag_hint: 'drag to reassign',
    class_created: 'Class "{{name}}" created',
    dept_created: 'Department "{{name}}" created',
    class_deleted: 'Class deleted',
    dept_deleted: 'Department deleted',
    moved_and_deleted: 'Students moved and department deleted',
    failed_load: 'Failed to load classes',
    failed_move: 'Failed to move student',
    failed_create_class: 'Failed to create class',
    failed_rename_class: 'Failed to rename class',
    failed_delete_class: 'Failed to delete class',
    failed_create_dept: 'Failed to create department',
    failed_rename_dept: 'Failed to rename department',
    failed_delete_dept: 'Failed to delete department',
    failed_move_delete: 'Failed to move students or delete department',
  },
  daily_register: {
    title: 'Daily Register',
    subtitle: 'Log attendance and daily activities',
  },
  daily_log: {
    title: 'Daily Log',
    open_log: 'Daily log',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    afternoon: 'Afternoon',
    slept: 'Slept',
    comments: 'Comments',
    comments_placeholder: 'Any notes about the child\'s day…',
    saved: 'Daily log saved for {{name}}',
  },
  attendance: {
    title: 'Daily Register',
    subtitle: 'Log daily arrivals and departures',
    date: 'Date',
    class: 'Class',
    all_classes: 'All classes',
    department: 'Department',
    all_departments: 'All departments',
    search_students: 'Search students…',
    arrived_stat: 'arrived',
    departed_stat: 'departed',
    arrival: 'Arrival',
    departure: 'Departure',
    log_arrival: 'Log Arrival',
    log_departure: 'Log Departure',
    log_arrival_note: 'Log Arrival with note',
    log_departure_note: 'Log Departure with note',
    undo_arrival: 'Click × to undo arrival',
    undo_departure: 'Click × to undo departure',
    chip_arrived: 'Arrived',
    chip_departed: 'Departed',
    chip_not_arrived: 'Not arrived',
    no_match: 'No students match your search',
    no_students: 'No students found',
    log_for: 'Log for {{date}}',
    no_records: 'No records for this date',
    time: 'Time',
    notes: 'Notes',
    notes_placeholder: 'e.g. Grandparent picked up the child',
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    remove: 'Remove',
    arrival_logged: 'Arrival logged for {{name}}',
    departure_logged: 'Departure logged for {{name}}',
    absent_logged: '{{name}} marked as absent',
    students_header: 'Students ({{count}})',
    prev_day: 'Previous day',
    next_day: 'Next day',
    future_locked: 'This is a future date — the register is read-only.',
    chip_absent: 'Will not come',
    log_absent: 'Mark as absent today',
    undo_absent: 'Click × to undo absence',
    no_log: 'No daily log entry for this date',
    view_profile: 'View Student Profile',
  },
  food: {
    title: 'Food Menu',
    subtitle: 'Monthly meal planner per class',
    class: 'Class',
    copy_month: 'Copy From Month',
    copy_tooltip: "Copy another month's menu into this month",
    show_weekends: 'Show weekends',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    afternoon: 'Afternoon',
    edit_meals: 'Edit meals',
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    copy: 'Copy',
    copying: 'Copying…',
    copy_dialog_title: 'Copy menu to {{month}} {{year}}',
    copy_dialog_body: 'Choose the source month to copy from. Existing meals in {{month}} {{year}} will be overwritten.',
    copy_class_label: 'Class to copy',
    copy_all_classes: 'All classes',
    month_label: 'Month',
    year_label: 'Year',
    copied_message: 'Copied {{count}} meal entries to {{month}} {{year}}',
    copy_empty_source: 'The source month has no meal entries to copy.',
    copy_failed: 'Failed to copy meal entries. Please try again.',
    also_apply_to: 'Also apply to other classes',
    no_extra_classes: 'Only this class',
    clear_month: 'Clear Month',
    clear_tooltip: 'Delete all meal entries for this month',
    clear_dialog_title: 'Clear {{month}} {{year}}?',
    clear_dialog_body: 'This will permanently delete all meal entries for {{month}} {{year}}. This action cannot be undone.',
    clear_confirm: 'Clear Month',
    clearing: 'Clearing…',
    cleared_message: 'All meals for {{month}} {{year}} have been cleared.',
    clear_failed: 'Failed to clear meal entries. Please try again.',
    export_week: 'Print Week',
    export_week_tooltip: 'Print this week\'s meal plan',
    export_month: 'Print Month',
    export_month_tooltip: "Print this month's meal plan",
    pdf_daily_title: 'Daily Food Report',
    pdf_week_title: 'Weekly Meal Plan',
    pdf_month_title: 'Monthly Meal Plan',
    pdf_class: 'Class',
    pdf_departments: 'Departments',
    pdf_no_meals: 'No meals planned',
    pdf_day: 'Day',
    months: {
      0: 'January', 1: 'February', 2: 'March', 3: 'April',
      4: 'May', 5: 'June', 6: 'July', 7: 'August',
      8: 'September', 9: 'October', 10: 'November', 11: 'December',
    },
    days: {
      mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu',
      fri: 'Fri', sat: 'Sat', sun: 'Sun',
    },
  },
  school: {
    title: 'School Settings',
    subtitle: "Manage your school's details and location",
    save_changes: 'Save Changes',
    saving: 'Saving…',
    general_info: 'General Info',
    school_name: 'School Name',
    address: 'Address',
    email: 'Email',
    website: 'Website',
    phone: 'Phone Number',
    mobile: 'Mobile Number',
    location: 'Location',
    location_hint: "Click on the map to set the school's location, or enter coordinates manually.",
    latitude: 'Latitude',
    longitude: 'Longitude',
    saved: 'School details saved',
    save_failed: 'Failed to save school details',
    route_replay_section: 'Route Replay',
    route_replay_label: 'Enable Route Replay',
    route_replay_hint: 'When enabled, GPS points are recorded during active routes and can be replayed on the map for the last 7 days.',
  },
  parent_today: {
    today_chip: 'Today',
    no_data: 'No data for this day.',
    load_error: 'Failed to load daily logs',
    absent: 'Absent',
    no_bus: 'No Bus',
    manage_absences: 'Manage Absences',
    arrival: 'Arrival',
    departure: 'Departure',
    meals: 'Meals',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    snack: 'Snack',
    nap: 'Nap',
  },
  reports: {
    title: 'Reports',
    subtitle: 'Daily attendance & child summaries',
    tab_daily: 'Daily Report',
    tab_child: 'Child Report',
    tab_routes: 'Routes',
    tab_birthdays: 'Birthdays',
    birthday_notification: '🎂 {{count}} birthday today! Click to view.',
    birthday_notification_plural: '🎂 {{count}} birthdays today! Click to view.',
    birthday_tab_title: 'Students with birthdays on',
    birthday_no_birthdays: 'No birthdays today.',
    birthday_col_name: 'Name',
    birthday_col_class: 'Class',
    birthday_col_department: 'Department',
    birthday_col_dob: 'Date of Birth',
    date_label: 'Date',
    export_pdf: 'Export PDF',
    export_tooltip: 'Export to PDF',
    all_classes: 'All classes',
    total: '{{count}} total',
    stat_arrived: '{{count}} arrived',
    stat_absent: '{{count}} absent',
    stat_pending: '{{count}} not yet arrived',
    col_child: 'Child',
    col_status: 'Status',
    col_arrival: 'Arrival',
    col_departure: 'Departure',
    col_breakfast: 'Breakfast',
    col_lunch: 'Lunch',
    col_afternoon: 'Afternoon',
    col_slept: 'Slept',
    col_notes: 'Notes',
    col_date: 'Date',
    col_day: 'Day',
    col_comments: 'Comments',
    col_in: 'In',
    col_out: 'Out',
    n_children: '{{count}} children',
    no_students: 'No students found.',
    status_absent: 'Absent',
    status_in_out: 'In / Out',
    status_arrived: 'Arrived',
    status_departed: 'Departed',
    select_child: 'Select child',
    weekly: 'Weekly',
    monthly: 'Monthly',
    select_child_hint: 'Select a child above to view their report.',
    days_present: '{{count}} / {{total}} days present',
    pdf_daily_title: 'Daily Attendance Report',
    pdf_date: 'Date:',
    pdf_school: 'School:',
    pdf_child_title: 'Child Report',
    pdf_child: 'Child:',
    pdf_class: 'Class:',
    pdf_period: 'Period:',
    pdf_status_absent: 'Absent',
    pdf_status_in_out: 'In/Out',
    pdf_status_arrived: 'Arrived',
    replay_btn: 'Replay',
    replay_title: 'Route Replay',
    replay_no_points: 'No GPS track recorded for this route.',
    replay_loading: 'Loading track…',
    replay_play: 'Play',
    replay_pause: 'Pause',
    replay_reset: 'Reset',
    replay_points_count: '{{count}} GPS points',
    replay_delete: 'Delete Points',
    replay_delete_confirm: 'Confirm Delete?',
  },
  messages: {
    title: 'Messages',
    compose: 'Compose',
    send: 'Send',
    sending: 'Sending…',
    no_messages: 'No messages sent yet',
    no_subject: '(No subject)',
    read: 'read',
    recipients: 'recipients',
    recipients_list: 'Recipients',
    children_attendance: 'Children Attendance',
    read_label: 'Read',
    unread_label: 'Unread',
    send_to: 'Send to',
    target_all: 'All parents',
    target_class: 'Class parents',
    target_department: 'Department parents',
    target_children: "Selected children's parents",
    target_all_routes: 'All routes parents',
    target_route: 'Route parents',
    pick_class: 'Select class',
    pick_department: 'Select department',
    pick_route: 'Select route',
    pick_children: 'Add children',
    search_child: 'Search student…',
    selected: 'selected',
    subject: 'Subject',
    message_body: 'Message',
    invitation: 'Invitation',
    invitation_toggle: 'Request RSVP',
    invitation_hint: 'Recipients can respond Yes / No / Maybe',
    rsvp_yes: 'Yes',
    rsvp_no: 'No',
    rsvp_maybe: 'Maybe',
    rsvp_none: 'No response',
    tab_sent: 'Sent',
    tab_received: 'Received',
    no_messages_received: 'No messages received',
    reply: 'Reply',
  },
  send_toast: {
    button_tooltip: 'Send In-App Notification',
    title: 'Send Notification',
    recipients: 'Recipients',
    message: 'Message',
    severity: 'Type',
    severity_info: 'Info',
    severity_success: 'Success',
    severity_warning: 'Warning',
    severity_error: 'Error',
    send: 'Send',
    cancel: 'Cancel',
    sent_ok: 'Sent to {{count}} user(s).',
    error: 'Failed to send. Please try again.',
  },
  map: {
    loading: 'Loading…',
    show_children: 'Show Children',
    hide_children: 'Hide Children',
    children_stops: '{{children}} children · {{stops}} stops',
    show_route: 'Show route',
    none: 'None',
    to_school_chip: '→ School',
    from_school_chip: '← Home',
    stop_of: 'Stop {{index}} of {{total}} · {{route}}',
    picked_up: 'picked up',
    dropped_off: 'dropped off',
    route_started: '{{driver}} started route {{route}}',
    route_stopped: '{{driver}} stopped route {{route}}',
    route_finished: '{{driver}} finished route {{route}}',
    route_started_alert_title: 'Route Started',
    route_started_alert_ok: 'Go to map',
    delay_set: '{{driver}} reported a {{minutes}}-min delay',
    early_set: '{{driver}} will arrive {{minutes}} min early',
    show_all_buses: 'Last Bus Positions',
    hide_all_buses: 'Hide All Buses',
    auto_zoom: 'Auto Zoom',
    last_known: 'Last known position',
    absent_today: 'Absent today',
    show_route_children: 'Active Route Children',
    hide_route_children: 'Hide Route Children',
    picked_up_at: 'Picked up at {{time}}',
    dropped_off_at: 'Dropped off at {{time}}',
    status_dropped_off: 'Dropped off',
    next_stop: 'Next stop',
    pending_pickup: 'Pending pickup',
    pending_dropoff: 'Pending drop-off',
    status_skipped: 'Skipped',
    status_picked_up: 'Picked up',
    dashboard_active_routes: 'Active routes',
    dashboard_picked_up: 'Picked up',
    dashboard_skipped: 'Skipped',
    dashboard_pending: 'Pending',
    dashboard_no_active: 'No active routes right now',
    active_route_filter: 'Active Route',
    all_active_routes: 'All active',
    active_routes_widget: 'Active Routes',
    close_route: 'Close Route',
    close_route_confirm: 'Force-close this route?',
    route_closed: 'Route closed',
    close_route_failed: 'Failed to close route',
    show_active_routes_panel: 'Active Routes',
    message_driver: 'Message driver',
    message_driver_title: 'Send message to driver',
    message_driver_placeholder: 'Type your message…',
    message_driver_send: 'Send',
    message_driver_sent: 'Message sent',
    message_driver_failed: 'Failed to send message',
    route_prefix: 'Route',
    status_finished: 'Finished',
    status_stopped: 'Stopped',
    early_min: 'Early {{minutes}} min',
    delayed_min: 'Delayed {{minutes}} min',
    updated_at: 'Updated',
  },
  routes: {
    title: 'Routes',
    subtitle: 'Manage bus routes and stops',
    loading: 'Loading routes\u2026',
    add: 'New Route',
    no_routes: 'No routes yet. Create your first route to get started.',
    to_school: 'To School',
    from_school: 'From School',
    one_time: 'One Time',
    stops: 'stops',
    stop_order: 'Stop Order',
    edit: 'Edit route',
    rename: 'Rename',
    delete: 'Delete',
    delete_confirm: 'Are you sure you want to delete "{{name}}"? This cannot be undone.',
    new_route: 'New Route',
    edit_route: 'Edit Route',
    route_name: 'Route Name',
    available_children: 'Available Children',
    filter_class: 'Class',
    filter_dept: 'Department',
    all_classes: 'All classes',
    all_depts: 'All departments',
    no_available_children: 'No children available for this route type.',
    route_stops: 'Route Stops',
    select_stops_hint: 'Click addresses in the list or map markers to add stops.',
    selected: 'Added',
    added: 'Added',
    add_stop: 'add stop',
    available: 'available',
    map_hint: 'click markers to add/remove',
    clear_filter: 'Clear',
    no_children_in_filter: 'No children match this filter.',
    created: 'Route created successfully',
    updated: 'Route updated successfully',
    renamed: 'Route renamed',
    deleted: 'Route deleted',
    save_failed: 'Failed to save route',
    save_requires_name: 'Enter a route name to save',
    save_requires_stops: 'Add at least one stop to save',
    save_requires_name_and_stops: 'Enter a route name and add at least one stop',
    tab_routes: 'Routes',
    tab_pending: 'Pending',
    pending_empty: 'All bus children have been assigned to routes.',
    pending_to_school: 'Needs to-school route',
    pending_from_school: 'Needs from-school route',
    no_address_warning: 'No address set — add a pickup/drop-off address first',
    optimize: 'Optimize Order',
    optimizing: 'Optimizing…',
    optimize_applied: 'Optimal order applied',
    optimize_undo: 'Undo',
    optimize_error: 'Could not optimize — routing service unavailable',
    optimize_too_few: 'Add at least 2 stops to optimize',
    depot_label: 'Bus Starting Point',
    depot_not_set: 'Not set (optional)',
    depot_set_on_map: 'Set on map',
    depot_cancel_pick: 'Cancel',
    depot_picking_hint: 'Click anywhere on the map to place the bus starting point',
    show_road_path: 'Show Road Path',
    hide_road_path: 'Hide Road Path',
    road_path_loading: 'Loading…',
    road_path_total: 'total route',
    start_time: 'Start Time',
    start_time_hint: 'Optional – when set, estimated arrival times are shown per stop when road path is enabled',
  },
  absences: {
    title: 'Bus Absences',
    manage: 'Manage Absences',
    for: 'Absences for {{name}}',
    no_absences: 'No absences scheduled.',
    add_absence: 'Add Absence',
    date_label: 'Date',
    reason_label: 'Reason (optional)',
    reason_placeholder: 'e.g. sick, out of town…',
    absent_today: 'Absent today',
    bus_absent_today: 'Not on bus',
    save: 'Add',
    delete_confirm: 'Remove this absence?',
    added: 'Absence added',
    removed: 'Absence removed',
    error: 'Failed to save absence',
    type_label: 'Absence type',
    type_full: 'Absent from school',
    type_bus: 'Bus absence only',
    routes_label: 'Absent from routes',
    skip_to_school: 'Morning (to school)',
    skip_from_school: 'Afternoon (from school)',
    chip_full: 'School',
    chip_bus: 'Bus',
  },
  common: {
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    ok: 'OK',
    yes: 'Yes',
    no: 'No',
    first_name: 'First Name',
    last_name: 'Last Name',
    email: 'Email',
    phone_number: 'Phone Number',
    actions: 'Actions',
    school: 'School:',
    logged_in: 'You are logged in to the homepage!',
    email_required: 'Email is required.',
    email_invalid: 'Please enter a valid email address.',
    first_name_required: 'First name is required.',
    last_name_required: 'Last name is required.',
    phone_number_required: 'Phone number is required.',
    phone_number_invalid: 'Phone number must contain only digits (max 14).',
    phone: 'Phone',
    status: 'Status',
    edit: 'Edit',
    delete: 'Delete',
    restore: 'Restore',
    app_version: 'Version {{version}}',
    network_error: 'Network error. Please check your connection and try again.',
    close: 'Close',
    no_rows: 'No rows',
    rows_per_page: 'Rows per page:',
    select_all: 'Select all',
    n_selected: '{{count}} selected',
    delete_n: 'Delete ({{count}})',
  },
  driver_map: {
    select_route: 'Select a route to begin',
    no_routes: 'No routes assigned to your school.',
    stops_active: '{{count}} stops · {{active}} active',
    stops_count: '{{count}} stops',
    to_school: 'To School',
    from_school: 'From School',
    route_label: 'Route',
    picked_count: '{{count}}/{{total}} picked up',
    delay_btn: 'Delay / Early',
    route_started: 'Route started',
    route_paused: 'Route cancelled',
    route_finished: 'Route finished!',
    child_picked_up: '{{name}} picked up',
    pickup_failed: 'Failed to record pickup',
    delay_reported: 'Delay of {{minutes}} min reported',
    early_reported: 'Early arrival of {{minutes}} min reported',
    report_delay_title: 'Delay / Early Arrival',
    early_section: 'Early Arrival',
    delay_section: 'Delay',
    first_stop: 'First stop',
    start_route: 'Start Route',
    next_stop: 'Next Stop',
    picked_up_btn: 'Picked Up',
    dropped_off_btn: 'Dropped Off',
    pause: 'Cancel',
    finish_route: 'Finish Route',
    all_done: 'All stops complete!',
    status_finished: 'Route finished',
    status_paused: 'Route cancelled',
    resume_route: 'Resume Route',
    report_delay: 'Report Delay',
    min: 'min',
    absent: 'Absent',
    status_picked_up: 'Picked up',
    upcoming: 'Upcoming',
    skip_btn: 'Skip',
    skip_confirm_title: 'Skip Child?',
    skip_confirm_msg: 'Skip {{name}} and move to the next stop?',
    child_skipped: '{{name}} skipped',
    skip_failed: 'Failed to record skip',
    status_skipped: 'Skipped',
    child_marked_absent: '{{name}} reported absent — stop removed from your route',
    geo_denied: 'Location access denied. The school cannot see your route.',
    geo_unavailable: 'Location unavailable. Check your device settings.',
    geo_no_support: 'Your browser does not support location tracking.',
    geo_fix_chrome: 'Click the lock icon in the address bar → Location → Allow, then reload.',
    geo_fix_edge: 'Click the lock icon in the address bar → Location → Allow, then reload.',
    geo_fix_firefox: 'Click the lock icon in the address bar → clear the Location permission, then reload.',
    geo_fix_safari_ios: 'Go to iOS Settings → Privacy & Security → Location Services → Safari → While Using.',
    geo_fix_safari_mac: 'In Safari → Settings → Websites → Location → allow this site, then reload.',
    geo_fix_samsung: 'Tap ⋮ → Settings → Sites and downloads → Location → allow this site, then reload.',
    geo_fix_other: 'Open your browser\'s site settings and allow Location for this page, then reload.',
    geo_reload: 'Reload',
    cancel_route_title: 'Cancel Route?',
    cancel_reason_traffic: 'Traffic / accident',
    cancel_reason_breakdown: 'Vehicle breakdown',
    cancel_reason_driver: 'Driver issue',
    cancel_reason_other: 'Other',
    confirm_cancel: 'Cancel Route',
    progress_restored: 'Progress restored — {{done}} stops already done',
    finish_pending_title: 'Finish with pending stops?',
    finish_pending_msg: '{{count}} child(ren) have not been picked up or skipped yet. Are you sure you want to finish the route?',
    finish_pending_confirm: 'Finish Anyway',
    nav_route_toggle: 'Route line',
    nav_route_no_location: 'Location not available yet — enable GPS and try again',
    nav_route_unavailable: 'Navigation service unavailable',
    recenter: 'Re-center',
    route_active_badge: 'Active',
    route_in_use_badge: 'In Use',
    route_taken_error: 'This route is already being driven by another driver.',
    already_active_error: 'You have an active route. Please finish it before starting another.',
    route_complete_title: 'Route Complete!',
    back_to_routes: 'Back to Routes',
    report_picked_up: 'Picked up',
    report_dropped_off: 'Dropped off',
    report_skipped: 'Skipped',
    report_absent: 'Absent',
    report_not_reached: 'Not reached',
    arrived_at_stop: 'You\'ve arrived at this stop!',
    dismiss: 'Dismiss',
    absent_popup_title: 'Absences on this route today',
    absent_popup_subtitle: '{{count}} child(ren) will not be picked up or dropped off today',
    mid_route_absence_title: 'Child removed from route',
    mid_route_absence_subtitle: '{{count}} child(ren) were just cancelled by a parent and removed from this run',
    view_absences_btn: 'View absences',
    manage_children_btn: 'Manage children',
    manage_children_title: 'Manage children on this route',
    manage_children_subtitle: 'Remove a child from today\'s run. Unstarted removals are lost if you leave this screen without starting the route.',
    remove_child_btn: 'Remove',
    undo_remove_btn: 'Undo',
    simulate_route: 'Simulate Route (Testing)',
    simulation_running: 'Simulation running',
    simulation_started: 'Simulation started',
    simulation_finished: 'Simulation finished!',
    simulation_stopped: 'Simulation stopped',
    wake_lock_native: 'Wake lock: native ✓',
    wake_lock_fallback_video: 'Wake lock: fallback video ✓',
    wake_lock_unsupported: 'Wake lock: unsupported ✗',
    wake_lock_failed: 'Wake lock: failed ✗',
    wake_lock_pending: 'Wake lock: checking…',
    simulation_no_stops: 'No active stops to simulate on this route',
    stop_simulation: 'Stop Simulation',
  },
  driver_settings: {
    subtitle: 'Manage your profile and account',
    role_driver: 'Driver',
    current_password: 'Current password',
    password_min_length: 'Password must be at least 6 characters.',
    password_change_failed: 'Failed to change password',
    save_failed: 'Failed to save',
    proximity_alert_label: 'Approach alert popup',
    proximity_alert_desc: "Show a popup with a confirm button when you're near the next child's stop",
    proximity_alert_sound_label: 'Approach alert sound',
    proximity_alert_sound_desc: 'Play a sound when the approach alert popup appears',
    route_absence_popup_label: 'Absences popup',
    route_absence_popup_desc: "Show a popup with today's absences when you select a route from the list",
  },
  parent_messages_page: {
    no_subject: '(No subject)',
    mark_read: 'Mark read',
    rsvp_yes: 'RSVP Yes',
    rsvp_no: 'RSVP No',
    rsvp_label: 'RSVP: {{response}}',
    compose: 'Compose',
    inbox: 'Inbox',
    sent_tab: 'Sent',
    empty_inbox: 'Your inbox is empty.',
    no_sent: 'No sent messages.',
    compose_title: 'New Message',
    send_to_label: 'Send to',
    send_to_school: 'School',
    send_to_classmates: "Parents from my child's class",
    no_classmates: 'No classmates found.',
    subject_label: 'Subject',
    message_label: 'Message',
    send_btn: 'Send',
    sent_success: 'Message sent',
    send_failed: 'Failed to send message',
    rsvp_confirmed: 'RSVP confirmed: {{response}}',
    no_parent: 'No parent registered',
    request_rsvp: 'Request RSVP',
  },
  parent_children_page: {
    no_children: 'No children linked to your account.',
    manage_absences: 'Manage Absences',
    manage_absences_for: 'Absences — {{name}}',
    report_absence: 'Report Absence',
    report_absence_for: 'Report Absence — {{name}}',
    attendance_history: 'Attendance History',
    from_label: 'From',
    to_label: 'To',
    reason_optional: 'Reason (optional)',
    report_btn: 'Add Absence',
    absence_reported: 'Absence saved',
    absence_saved: 'Absence saved',
    absence_failed: 'Failed to save absence',
    absence_deleted: 'Absence removed',
    absent_today: 'Absent today',
    bus_absent_today: 'Not on bus today',
    type_label: 'Type',
    type_full: 'Absent from school',
    type_bus: 'Bus absence only',
    routes_label: 'Routes to skip',
    skip_to_school: 'Morning (to school)',
    skip_from_school: 'Afternoon (from school)',
    scheduled: 'Scheduled absences',
    no_scheduled: 'No absences scheduled.',
    by_school: 'Entered by school',
    chip_full: 'School',
    chip_bus: 'Bus',
    period_7d: 'Last 7 days',
    period_30d: 'Last 30 days',
    period_3m: 'Last 3 months',
    period_6m: 'Last 6 months',
    period_1y: 'Last year',
    stat_present_pct: 'Present %',
    stat_absences: 'Absences',
    stat_avg_arrival: 'Avg Arrival',
    stat_avg_departure: 'Avg Departure',
    stat_breakfasts: 'Breakfasts',
    stat_lunches: 'Lunches',
  },
  parent_bus_tracking_page: {
    title: 'Live Bus Tracking',
    no_session: 'No active tracking session',
    no_session_desc: 'The bus is not currently being tracked. This page will update automatically when a route starts.',
    checking: 'Checking every 10 seconds…',
    back: 'Back',
    tracking_ended: 'Tracking ended',
    session_inactive: 'Session is no longer active.',
    watch_new: 'Watch for new session',
    go_back: 'Go back',
    expires_in: 'Expires in {{countdown}}',
    waiting_location: 'Waiting for bus location…',
    status_child_picked_up: 'Child has been picked up.',
    status_child_skipped: 'The driver skipped this stop.',
    status_route_stopped: 'Route has ended.',
    status_expired: 'Tracking session expired.',
    status_unreachable: 'Connection lost after 3 failed attempts.',
    status_invalid: 'Tracking session not found or has already ended.',
  },
  parent_stats: {
    title: 'Statistics',
    week: 'This Week',
    month: 'This Month',
    year: 'This Year',
    days_logged: 'days logged',
    food: 'Food',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    afternoon: 'Afternoon Snack',
    days: 'days',
    avg: 'avg',
    per_day: 'servings/day',
    sleep: 'Sleep',
    naps: 'Naps',
    absences: 'Absences',
    full_absences: 'Full-day absences',
    bus_only_absences: 'Bus skipped',
    no_data: 'No data available for this period.',
    load_error: 'Failed to load statistics.',
  },
  parent_menu_page: {
    load_error: 'Failed to load meal menu.',
    no_menu: 'No menu available for this week.',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    afternoon: 'Afternoon',
    no_meal: 'Not set',
  },
  parent_settings_page: {
    subtitle: 'Manage your profile and account',
    role_parent: 'Parent',
    allow_messages: 'Allow parent messages',
    current_password: 'Current password',
    password_min_length: 'Password must be at least 6 characters.',
    password_change_failed: 'Failed to change password',
    save_failed: 'Failed to save changes',
    danger_zone: 'Danger Zone',
    danger_desc: 'Permanently delete your account. This action cannot be undone.',
    delete_account: 'Delete Account',
    delete_confirm: 'Enter your password to confirm account deletion.',
    password_placeholder: 'Password',
    delete_btn: 'Delete',
    account_deleted: 'Account deleted. Logging out...',
    delete_failed: 'Failed to delete account',
    notifications_title: 'Notifications',
    web_notifications: 'Browser notifications',
    notifications_desc: 'Get notified when you receive a new message.',
    notifications_active: 'You will be notified for new messages.',
    notifications_unblock_hint: 'Blocked by your browser. To re-enable, open your browser site settings and allow notifications for this site, then come back here.',
    ios_push_hint: 'To enable notifications on iPhone, open the app from your Home Screen icon, then tap "Enable" on the banner that appears.',
    blocked: 'Blocked',
    mobile_notifications: 'Mobile app notifications',
    mobile_notifications_desc: 'Push notifications on your phone via the parent app.',
    notifications_enabled: 'Notifications enabled!',
    notifications_denied: 'Permission denied. Please allow notifications in your browser settings.',
    notify_types_title: 'Notify me when',
    notify_route_start: 'Route starts or ends',
    notify_route_start_desc: 'When the bus departs or arrives at school',
    notify_bus_near: 'Bus is approaching',
    notify_bus_near_desc: 'When the bus is close to your pickup stop',
    notify_bus_arriving: 'Bus arriving now',
    notify_bus_arriving_desc: 'When the bus is just metres away from your stop',
    notify_pick_drop: 'Child picked up / dropped off',
    notify_pick_drop_desc: 'When your child boards or exits the bus',
    notify_messages: 'New message from school',
    notify_messages_desc: 'When the school sends you a message',
    notify_delays: 'Delays & early arrivals',
    notify_delays_desc: 'When the bus is delayed or running ahead of schedule',
  },
  push_prompt: {
    message: 'Enable notifications to get alerts when you receive new messages.',
    enable: 'Enable',
    ios_install: 'To receive bus notifications on iPhone, tap the Share button (↑) and choose "Add to Home Screen", then open the app from there.',
  },
  pwa_install: {
    message: 'Install this app on your phone for a better experience.',
    ios_message: 'Install this app: tap the Share button then "Add to Home Screen".',
    install: 'Install',
    install_app: 'Add to Home Screen',
  },
  update_banner: {
    message: 'A new version is available.',
    refresh: 'Refresh',
  },
  parent_help_page: {
    title: 'Help',
    subtitle: 'Frequently asked questions',
    go_to_settings: 'Go to Settings',
    q_ios_notif: 'How do I enable notifications on iPhone / iPad?',
    ios_step1: 'Open this page in Safari.',
    ios_step2: 'Tap the Share button (the box with an arrow pointing up).',
    ios_step3: 'Scroll down and tap "Add to Home Screen".',
    ios_step4: 'Tap "Add" in the top-right corner.',
    ios_step5: 'Open the app from your Home Screen.',
    ios_step6: 'Go to Settings → Notifications and enable them.',
    ios_note: 'Web notifications on iPhone require the app to be installed to your Home Screen first (iOS 16.4+).',
    q_android_notif: 'How do I enable notifications on Android?',
    android_step1: 'Tap the three-dot menu in the top-right corner.',
    android_step2: 'Tap "Add to Home Screen" or "Install App".',
    android_step3: 'Open the app from your Home Screen.',
    android_step4: 'Go to Settings → Notifications and enable them.',
    q_desktop_notif: 'How do I enable notifications on my computer?',
    desktop_step1: 'Go to Settings → Notifications.',
    desktop_step2: 'Enable the "Browser notifications" toggle.',
    desktop_step3: 'Allow notifications when your browser asks.',
    q_notif_preview: 'Notifications show only a short preview — how do I always see the full message?',
    notif_preview_intro: 'The easiest fix is to change your phone\'s notification preview setting so the full message always appears.',
    ios_preview_title: 'iPhone',
    ios_preview_step1: 'Open the iPhone Settings app.',
    ios_preview_step2: 'Go to Notifications → [App name].',
    ios_preview_step3: 'Tap "Show Previews" and select "Always".',
    android_preview_title: 'Android',
    android_preview_step1: 'Open Settings → Apps → [App name].',
    android_preview_step2: 'Tap Notifications.',
    android_preview_step3: 'Enable "Show sensitive content" or set previews to "Always".',
    q_ios_expand: 'How do I expand a single notification on iPhone without changing settings?',
    ios_expand_step1: 'Long-press the notification on your lock screen.',
    ios_expand_step2: 'Tap "View" to see the full text.',
    ios_expand_step3: 'Or swipe left on the notification and tap "View".',
    ios_expand_step4: 'If the notification is gone, open the app and check the Messages tab.',
    q_android_expand: 'How do I expand a single notification on Android without changing settings?',
    android_expand_step1: 'Drag the notification banner downward to expand it.',
    android_expand_step2: 'If it has been dismissed, pull down the notification shade to find it.',
    android_expand_step3: 'Tap the notification to open the app and read the full message.',
  },
};

const el = {
  nav: {
    students: 'Μαθητές',
    departments: 'Τμήματα',
    map: 'Χάρτης',
    parents: 'Γονείς',
    drivers: 'Οδηγοί',
    teachers: 'Δάσκαλοι',
    routes: 'Διαδρομές',
    food: 'Φαγητό',
    attendance: 'Ημερήσιο Μητρώο',
    reports: 'Αναφορές',
    messages: 'Μηνύματα',
    driver_map: 'Χάρτης',
    driver_settings: 'Ρυθμίσεις',
    parent_today: 'Σήμερα',
    parent_bus_tracking: 'Παρακολούθηση',
    parent_menu: 'Διατροφολόγιο',
    parent_messages: 'Μηνύματα',
    parent_children: 'Παιδιά',
    parent_stats: 'Στατιστικά',
    parent_settings: 'Ρυθμίσεις',
  },
  header: {
    signed_in_as: 'Συνδεδεμένος ως',
    logout: 'Αποσυνδεση',
    preferences: 'Προτιμήσεις',
    help: 'Βοήθεια',
    donate: 'Κράτα το λεωφορείο στο δρόμο ☕',
    enable_notifications: 'Ενεργοποίηση Ειδοποιήσεων',
    notifications_on: 'Ειδοποιήσεις Ενεργές',
  },
  preferences: {
    title: 'Προτιμήσεις',
    subtitle: 'Διαχείριση στοιχείων λογαριασμού και κωδικού',
    personal_info: 'Προσωπικά Στοιχεία',
    first_name: 'Όνομα',
    last_name: 'Επώνυμο',
    email: 'Email',
    phone_number: 'Κινητό Τηλέφωνο',
    save: 'Αποθήκευση',
    saved: 'Οι αλλαγές αποθηκεύτηκαν',
    save_error: 'Αποτυχία αποθήκευσης',
    change_password: 'Αλλαγή Κωδικού',
    new_password: 'Νέος Κωδικός',
    confirm_password: 'Επιβεβαίωση Κωδικού',
    update_password: 'Ενημέρωση Κωδικού',
    password_saved: 'Ο κωδικός ενημερώθηκε',
    password_mismatch: 'Οι κωδικοί δεν ταιριάζουν',
    notifications: 'Προτιμήσεις Ειδοποιήσεων',
    notifications_subtitle: 'Επιλέξτε ποιες ειδοποιήσεις push θέλετε να λαμβάνετε',
    notify_route_start: 'Εκκίνηση διαδρομής',
    notify_route_start_desc: 'Όταν ο οδηγός ξεκινά μια διαδρομή',
    notify_route_end: 'Λήξη διαδρομής',
    notify_route_end_desc: 'Όταν ο οδηγός τελειώνει μια διαδρομή',
    notify_pickup: 'Επιβίβαση / αποβίβαση παιδιού',
    notify_pickup_desc: 'Όταν ένα παιδί επιβιβάζεται ή αποβιβάζεται από το λεωφορείο',
    notify_skip: 'Παράλειψη στάσης παιδιού',
    notify_skip_desc: 'Όταν ο οδηγός παραλείπει ένα παιδί στη στάση του',
    notify_delay: 'Καθυστέρηση / πρόωρη άφιξη',
    notify_delay_desc: 'Όταν ο οδηγός αναφέρει καθυστέρηση ή πρόωρη άφιξη',
    notify_saved: 'Οι προτιμήσεις ειδοποιήσεων αποθηκεύτηκαν',
  },
  login: {
    welcome_back: 'Καλώς ήρθατε',
    subtitle: 'Συνδεθείτε στον πίνακα ελέγχου SB2',
    username: 'Email',
    password: 'Κωδικός',
    enter_username: 'Εισάγετε το email σας',
    enter_password: 'Εισάγετε τον κωδικό',
    forgot_password: 'Ξεχάσατε τον κωδικό;',
    sign_in: 'Συνδεση',
    signing_in: 'Σύνδεση…',
    tagline_line1: 'Κάθε παιδί,',
    tagline_line2: 'κάθε διαδρομή,',
    tagline_accented: 'με ασφάλεια.',
    description: 'Διαχείριση μαθητών, οδηγών, διαδρομών και παρουσιών. Επικοινωνία με γονείς, παρακολούθηση λεωφορείων σε πραγματικό χρόνο και εκτέλεση καθημερινών λειτουργιών — όλα σε ένα μέρος.',
    active_routes: 'Ενεργές Διαδρομές',
    students_stat: 'Μαθητές',
    on_time: 'Στην Ώρα',
    footer_note: 'Μόνο εξουσιοδοτημένο προσωπικό. Επικοινωνήστε με τον διαχειριστή σας.',
    error_user_not_found: 'Δεν βρέθηκε λογαριασμός με αυτό το email.',
    error_wrong_password: 'Λανθασμένος κωδικός. Παρακαλώ δοκιμάστε ξανά.',
    error_connection: 'Αδυναμία σύνδεσης. Ελέγξτε το δίκτυό σας και δοκιμάστε ξανά.',
    error_unknown: 'Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά.',
    error_too_many_requests: 'Πολλές προσπάθειες. Παρακαλώ περιμένετε λίγο και δοκιμάστε ξανά.',
    fp_title: 'Επαναφορά κωδικού',
    fp_subtitle: 'Εισάγετε το email σας και θα σας στείλουμε έναν 6ψήφιο κωδικό.',
    fp_email_label: 'Διεύθυνση Email',
    fp_email_placeholder: 'Εισάγετε το email σας',
    fp_send_code: 'Αποστολή Κωδικού',
    fp_sending: 'Αποστολή…',
    fp_code_sent: 'Ένας 6ψήφιος κωδικός στάλθηκε στο email σας.',
    fp_code_label: 'Κωδικός Επαλήθευσης',
    fp_code_placeholder: 'Εισάγετε 6ψήφιο κωδικό',
    fp_verify_code: 'Επαλήθευση Κωδικού',
    fp_verifying: 'Επαλήθευση…',
    fp_new_password_label: 'Νέος Κωδικός',
    fp_new_password_placeholder: 'Τουλάχιστον 6 χαρακτήρες',
    fp_confirm_password_label: 'Επιβεβαίωση Κωδικού',
    fp_confirm_password_placeholder: 'Επαναλάβετε τον νέο κωδικό',
    fp_save_password: 'Ορισμός Νέου Κωδικού',
    fp_saving: 'Αποθήκευση…',
    fp_back_to_login: 'Επιστροφή στη σύνδεση',
    fp_back: 'Πίσω',
    fp_success: 'Ο κωδικός σας επαναφέρθηκε. Μπορείτε τώρα να συνδεθείτε.',
    fp_error_invalid_code: 'Μη έγκυρος ή ληγμένος κωδικός. Παρακαλώ δοκιμάστε ξανά.',
    fp_error_password_mismatch: 'Οι κωδικοί δεν ταιριάζουν.',
    fp_error_password_short: 'Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.',
    fp_error_send: 'Αποτυχία αποστολής κωδικού. Παρακαλώ δοκιμάστε ξανά.',
    fp_error_email_not_found: 'Δεν βρέθηκε λογαριασμός με αυτή τη διεύθυνση email.',
    fp_resend: 'Εκ νέου αποστολή κωδικού',
    register_link: 'Νέος χρήστης; Εγγραφή',
    parent_app_android: 'Εφαρμογή γονέα για Android',
    parent_app_google_play: 'Διαθέσιμο στο Google Play',
    reg_title: 'Δημιουργία Λογαριασμού',
    reg_choose_role: 'Είμαι...',
    reg_role_parent: 'Γονέας',
    reg_role_parent_desc: 'Εγγραφή για παρακολούθηση του σχολικού λεωφορείου',
    reg_role_driver: 'Οδηγός',
    reg_role_driver_desc: 'Το σχολείο σας πρέπει να δημιουργήσει πρώτα τον λογαριασμό σας',
    reg_role_teacher: 'Δάσκαλος',
    reg_role_teacher_desc: 'Το σχολείο σας πρέπει να δημιουργήσει πρώτα τον λογαριασμό σας',
    reg_teacher_email_title: 'Εγγραφή Εκπαιδευτικού',
    reg_teacher_email_subtitle: 'Εισάγετε το email που χρησιμοποίησε το σχολείο σας για να δημιουργήσει τον λογαριασμό σας.',
    reg_teacher_no_account: 'Δεν βρέθηκε λογαριασμός εκπαιδευτικού με αυτό το email. Επικοινωνήστε με το σχολείο σας.',
    reg_teacher_already_active: 'Αυτός ο λογαριασμός είναι ήδη ενεργός. Παρακαλώ συνδεθείτε.',
    reg_back: 'Πίσω',
    reg_next: 'Επόμενο',
    reg_submit: 'Εγγραφή',
    reg_driver_email_title: 'Εγγραφή Οδηγού',
    reg_driver_email_subtitle: 'Εισάγετε το email που χρησιμοποίησε το σχολείο σας για να δημιουργήσει τον λογαριασμό σας.',
    reg_driver_email_label: 'Διεύθυνση Email',
    reg_driver_email_placeholder: 'Εισάγετε το email σας',
    reg_driver_no_account: 'Δεν βρέθηκε λογαριασμός οδηγού με αυτό το email. Επικοινωνήστε με το σχολείο σας.',
    reg_driver_already_active: 'Αυτός ο λογαριασμός είναι ήδη ενεργός. Παρακαλώ συνδεθείτε.',
    reg_code_title: 'Εισαγωγή Κωδικού Επαλήθευσης',
    reg_code_subtitle: 'Ένας 6ψήφιος κωδικός στάλθηκε στο email σας.',
    reg_code_label: 'Κωδικός Επαλήθευσης',
    reg_code_placeholder: 'Εισάγετε 6ψήφιο κωδικό',
    reg_code_verify: 'Επαλήθευση',
    reg_resend: 'Εκ νέου αποστολή κωδικού',
    reg_resend_limit: 'Το όριο αποστολής έχει εξαντληθεί.',
    reg_parent_info_title: 'Εγγραφή Γονέα',
    reg_parent_first_name: 'Όνομα',
    reg_parent_last_name: 'Επώνυμο',
    reg_parent_email: 'Διεύθυνση Email',
    reg_parent_first_name_placeholder: 'Εισάγετε το όνομά σας',
    reg_parent_last_name_placeholder: 'Εισάγετε το επώνυμό σας',
    reg_parent_email_placeholder: 'Εισάγετε το email σας',
    reg_password_title: 'Ορισμός Κωδικού',
    reg_new_password: 'Κωδικός',
    reg_new_password_placeholder: 'Τουλάχιστον 6 χαρακτήρες',
    reg_confirm_password: 'Επιβεβαίωση Κωδικού',
    reg_confirm_password_placeholder: 'Επαναλάβετε τον κωδικό σας',
    reg_set_password: 'Ορισμός Κωδικού',
    reg_done_title: 'Ο λογαριασμός δημιουργήθηκε!',
    reg_done_subtitle: 'Ο λογαριασμός σας είναι έτοιμος. Μπορείτε τώρα να συνδεθείτε.',
    reg_back_to_login: 'Επιστροφή στη σύνδεση',
    reg_error_invalid_code: 'Μη έγκυρος ή ληγμένος κωδικός. Παρακαλώ δοκιμάστε ξανά.',
    reg_error_password_mismatch: 'Οι κωδικοί δεν ταιριάζουν.',
    reg_error_password_short: 'Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.',
    reg_error_send: 'Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά.',
    reg_agree_terms: 'Αποδέχομαι τους',
    reg_terms_link: 'Όρους Χρήσης',
    reg_and: 'και την',
    reg_privacy_link: 'Πολιτική Απορρήτου',
    reg_must_agree: 'Πρέπει να αποδεχτείτε τους Όρους Χρήσης και την Πολιτική Απορρήτου για να συνεχίσετε.',
  },
  cookie: {
    message: 'Χρησιμοποιούμε cookies και τοπική αποθήκευση για να σας διατηρούμε συνδεδεμένους και να θυμόμαστε τις προτιμήσεις σας.',
    privacy_link: 'Πολιτική Απορρήτου',
    accept: 'Αποδοχή',
  },
  students: {
    title: 'Μαθητές',
    subtitle: 'Διαχειριστείτε εγγεγραμμένους μαθητές και τα στοιχεία τους',
    add: 'Προσθηκη Μαθητη',
    add_title: 'Προσθήκη Νέου Μαθητή',
    edit_title: 'Επεξεργασία Μαθητή',
    loading: 'Φόρτωση μαθητών…',
    search: 'Αναζήτηση μαθητών…',
    first_name: 'Όνομα',
    surname: 'Επώνυμο',
    last_name: 'Επώνυμο',
    school_class: 'Σχολική Τάξη',
    department: 'Τμήμα',
    school_bus: 'Σχολικό Λεωφορείο',
    parents_col: 'Γονείς',
    actions: 'Ενέργειες',
    edit: 'Επεξεργασια μαθητη',
    send_message: 'Αποστολη μηνυματος',
    delete: 'Διαγραφη μαθητη',
    delete_confirm: 'Είστε σίγουροι ότι θέλετε να διαγράψετε τον μαθητή;',
    bus_to: 'Λεωφορείο προς σχολείο',
    bus_from: 'Λεωφορείο από σχολείο',
    personal_info: 'Προσωπικά Στοιχεία',
    school_info: 'Σχολικές Πληροφορίες',
    transportation: 'Μεταφορά',
    parents_guardians: 'Γονείς / Κηδεμόνες',
    go_to_edit_parent: 'Μετάβαση στην επεξεργασία γονέα',
    add_new_parent: 'Νέος Γονέας',
    create_parent_title: 'Δημιουργία Νέου Γονέα',
    addresses: 'Διευθύνσεις Παραλαβής / Αποβίβασης',
    add_address: 'Προσθηκη Διευθυνσης',
    updated: 'Ο μαθητής ενημερώθηκε επιτυχώς!',
    created: 'Ο μαθητής δημιουργήθηκε επιτυχώς!',
    failed_to_save: 'Αποτυχία αποθήκευσης μαθητή. Παρακαλώ δοκιμάστε ξανά.',
    save_changes: 'Αποθηκευση Αλλαγων',
    first_name_required: 'Το όνομα είναι υποχρεωτικό',
    surname_required: 'Το επώνυμο είναι υποχρεωτικό',
    school_class_required: 'Η σχολική τάξη είναι υποχρεωτική',
    department_required: 'Το τμήμα είναι υποχρεωτικό',
    dob_required: 'Η ημερομηνία γέννησης είναι υποχρεωτική',
    date_of_birth: 'Ημερομηνία Γέννησης',
    dob_day: 'Μέρα',
    dob_month: 'Μήνας',
    dob_year: 'Έτος',
    comments: 'Σχόλια',
    comments_placeholder: 'Σημειώσεις για αυτό το παιδί…',
    address_label: 'Διεύθυνση',
    address_hint: 'Συμπληρώνεται αυτόματα κατά την αναζήτηση ή κάνοντας κλικ στον χάρτη',
    search_address: 'Αναζητήστε μια διεύθυνση…',
    address_comments: 'Σχόλια',
    month_jan: 'Ιανουάριος', month_feb: 'Φεβρουάριος', month_mar: 'Μάρτιος',
    month_apr: 'Απρίλιος', month_may: 'Μάιος', month_jun: 'Ιούνιος',
    month_jul: 'Ιούλιος', month_aug: 'Αύγουστος', month_sep: 'Σεπτέμβριος',
    month_oct: 'Οκτώβριος', month_nov: 'Νοέμβριος', month_dec: 'Δεκέμβριος',
    show_inactive: 'Εμφάνιση ανενεργών',
    route_assigned_to: 'Προς σχολείο: {{name}}',
    route_assigned_from: 'Από σχολείο: {{name}}',
    route_not_assigned: 'Χωρίς ανατεθειμένη διαδρομή',
    filter_needs_route: 'Χρειάζεται δρομολόγιο',
    filter_has_route: 'Έχει δρομολόγιο',
  },
  drivers: {
    title: 'Οδηγοί',
    subtitle: 'Διαχειριστείτε οδηγούς λεωφορείων και τα στοιχεία τους',
    add: 'Προσθηκη Οδηγου',
    loading: 'Φόρτωση οδηγών…',
    search: 'Αναζήτηση οδηγών…',
    actions: 'Ενέργειες',
    edit: 'Επεξεργασια οδηγου',
    delete: 'Διαγραφη οδηγου',
    delete_confirm: 'Είστε σίγουροι ότι θέλετε να διαγράψετε τον οδηγό;',
    add_title: 'Προσθήκη Οδηγού',
    edit_title: 'Επεξεργασία Οδηγού',
    failed_to_load: 'Αποτυχία φόρτωσης δεδομένων οδηγού.',
    not_found: 'Ο οδηγός δεν βρέθηκε.',
    failed_to_save: 'Αποτυχία αποθήκευσης οδηγού.',
    activated: 'Ενεργοποίηση',
    activatedYes: 'Ενεργός',
    activatedNo: 'Εκκρεμής',
    show_inactive: 'Εμφάνιση ανενεργών',
  },
  teachers: {
    title: 'Δάσκαλοι',
    subtitle: 'Διαχειριστείτε δασκάλους σχολείου και τα στοιχεία τους',
    add: 'Προσθηκη Δασκαλου',
    loading: 'Φόρτωση δασκάλων…',
    search: 'Αναζήτηση δασκάλων…',
    actions: 'Ενέργειες',
    edit: 'Επεξεργασια δασκαλου',
    delete: 'Διαγραφη δασκαλου',
    delete_confirm: 'Είστε σίγουροι ότι θέλετε να διαγράψετε τον δάσκαλο;',
    add_title: 'Προσθήκη Δάσκαλου',
    edit_title: 'Επεξεργασία Δάσκαλου',
    failed_to_load: 'Αποτυχία φόρτωσης δεδομένων δάσκαλου.',
    not_found: 'Ο δάσκαλος δεν βρέθηκε.',
    failed_to_save: 'Αποτυχία αποθήκευσης δάσκαλου.',
    show_inactive: 'Εμφάνιση ανενεργών',
  },
  parents: {
    title: 'Γονείς',
    no_children: 'Χωρίς παιδιά',
    search: 'Αναζήτηση γονέων…',
    add: 'Προσθηκη Γονεα',
    filter_by_class: 'Φίλτρο ανά Τάξη',
    filter_by_dept: 'Φίλτρο ανά Τμήμα',
    all_classes: 'Όλες οι τάξεις',
    all_departments: 'Όλα τα τμήματα',
    send_message: 'Αποστολη Μηνυματος ({{count}})',
    subject: 'Θέμα',
    message: 'Μήνυμα',
    sending: 'Αποστολη…',
    send: 'Αποστολη',
    send_to: 'Αποστολη Μηνυματος σε {{count}} γονέα',
    send_to_plural: 'Αποστολη Μηνυματος σε {{count}} γονείς',
    of_parents: '{{count}} από {{total}} γονείς',
    add_title: 'Προσθήκη Γονέα',
    edit_title: 'Επεξεργασία Γονέα',
    search_address: 'Αναζήτηση διεύθυνσης…',
    address: 'Διεύθυνση',
    address_optional: '(προαιρετικό)',
    remove_address: 'Αφαίρεση διεύθυνσης',
    address_hint: 'Συμπληρώνεται αυτόματα με αναζήτηση ή κλικ στον χάρτη — ή πληκτρολογήστε χειροκίνητα',
    notes_placeholder: 'Σχόλια για αυτόν τον γονέα…',
    notes: 'Σημειώσεις',
    assign_children: 'Ανάθεση Παιδιών',
    search_children: 'Αναζήτηση παιδιών…',
    cancel: 'Ακυρωση',
    save: 'Αποθηκευση',
    saving: 'Αποθηκευση…',
    email_required: 'Το email είναι υποχρεωτικό.',
    email_invalid: 'Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email.',
    failed_to_save: 'Αποτυχία αποθήκευσης γονέα.',
    created: 'Ο γονέας δημιουργήθηκε με επιτυχία.',
    updated: 'Ο γονέας ενημερώθηκε με επιτυχία.',
    email_exists: 'Υπάρχει ήδη γονέας με αυτό το email.',
    email_exists_deleted: 'Ένας γονέας με αυτό το email είχε διαγραφεί προηγουμένως από αυτό το σχολείο. Μπορείτε να τον επαναφέρετε αντί να δημιουργήσετε νέο.',
    restore_action: 'Επαναφορά',
    restoring: 'Επαναφορά…',
    restored: '{{name}} επαναφέρθηκε.',
    first_name: 'Όνομα',
    last_name: 'Επώνυμο',
    email: 'Email *',
    phone: 'Τηλέφωνο',
    children_col: 'Παιδιά',
    phone_col: 'Τηλέφωνο',
    status_active: 'Εγγεγραμμένος',
    status_inactive: 'Ανενεργός',
    status_deleted: 'Διαγραμμένος',
    show_no_children: 'Εμφάνιση χωρίς παιδιά',
    show_inactive: 'Εμφάνιση ανενεργών',
    show_deleted: 'Εμφάνιση διαγραμμένων',
    confirm_delete: 'Διαγραφή {{name}} από αυτό το σχολείο;',
    delete_action: 'Διαγραφή',
    deleting: 'Διαγραφή…',
    deleted: '{{name}} διαγράφηκε.',
    duplicate_warning: 'Διπλότυπο: {{name}} ({{email}}) έχει {{count}} προφίλ.',
    merge: 'Συγχώνευση',
    merge_title: 'Συγχώνευση Διπλότυπων Προφίλ',
    merge_description: 'Επιλέξτε ποιο προφίλ θέλετε να κρατήσετε. Το άλλο προφίλ θα διαγραφεί και τα δεδομένα του (παιδιά, τηλέφωνο) θα ενσωματωθούν στο κρατημένο.',
    merge_keep_label: 'Κρατήστε αυτό το προφίλ:',
    merge_confirm: 'Συγχώνευση',
  },
  departments: {
    title: 'Τάξεις & Τμήματα',
    loading: 'Φόρτωση τμημάτων…',
    new_class: 'Νεα Ταξη',
    no_classes: 'Δεν υπάρχουν τάξεις',
    no_classes_hint: 'Δημιουργήστε την πρώτη σας τάξη',
    no_depts: 'Δεν υπάρχουν τμήματα',
    add_dept: 'Προσθηκη τμηματος',
    delete_dept: 'Διαγραφη τμηματος',
    delete_class: 'Διαγραφη ταξης',
    rename: 'Μετονομασια',
    drop_here: 'Σύρετε μαθητές εδώ',
    release_to_drop: 'Αφήστε για τοποθέτηση',
    create: 'Δημιουργια',
    new_class_placeholder: 'π.χ. Γ\' Δημοτικού',
    new_dept_title: 'Νέο Τμήμα',
    new_dept_placeholder: 'π.χ. Πρωινό Γκρουπ',
    delete_class_title: 'Διαγραφη Ταξης',
    delete_dept_title: 'Διαγραφη Τμηματος',
    delete_confirm: 'Είστε σίγουροι ότι θέλετε να διαγράψετε το "{{name}}"; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    reassign_title: 'Διαγραφή Τμήματος "{{name}}"',
    reassign_students: 'Αυτό το τμήμα έχει {{count}} μαθητή. Επιλέξτε τμήμα για μεταφορά πριν τη διαγραφή.',
    reassign_students_plural: 'Αυτό το τμήμα έχει {{count}} μαθητές. Επιλέξτε τμήμα για μεταφορά πριν τη διαγραφή.',
    no_other_depts: 'Δεν υπάρχουν άλλα τμήματα. Δημιουργήστε ένα πρώτα.',
    move_to: 'Μεταφορά μαθητών σε',
    move_and_delete: 'Μεταφορα & Διαγραφη',
    n_classes: '{{count}} τάξη',
    n_classes_plural: '{{count}} τάξεις',
    n_students: '{{count}} μαθητής',
    n_students_plural: '{{count}} μαθητές',
    n_depts: '{{count}} τμήμα',
    n_depts_plural: '{{count}} τμήματα',
    drag_hint: 'σύρτε για ανάθεση',
    class_created: 'Η τάξη "{{name}}" δημιουργήθηκε',
    dept_created: 'Το τμήμα "{{name}}" δημιουργήθηκε',
    class_deleted: 'Η τάξη διαγράφηκε',
    dept_deleted: 'Το τμήμα διαγράφηκε',
    moved_and_deleted: 'Οι μαθητές μεταφέρθηκαν και το τμήμα διαγράφηκε',
    failed_load: 'Αποτυχία φόρτωσης τάξεων',
    failed_move: 'Αποτυχία μεταφοράς μαθητή',
    failed_create_class: 'Αποτυχία δημιουργίας τάξης',
    failed_rename_class: 'Αποτυχία μετονομασίας τάξης',
    failed_delete_class: 'Αποτυχία διαγραφής τάξης',
    failed_create_dept: 'Αποτυχία δημιουργίας τμήματος',
    failed_rename_dept: 'Αποτυχία μετονομασίας τμήματος',
    failed_delete_dept: 'Αποτυχία διαγραφής τμήματος',
    failed_move_delete: 'Αποτυχία μεταφοράς μαθητών ή διαγραφής τμήματος',
  },
  daily_register: {
    title: 'Ημερήσιο Μητρώο',
    subtitle: 'Καταγραφή παρουσιών και ημερήσιων δραστηριοτήτων',
  },
  daily_log: {
    title: 'Ημερήσιο Ημερολόγιο',
    open_log: 'Ημερήσιο ημερολόγιο',
    breakfast: 'Πρωινό',
    lunch: 'Μεσημεριανό',
    afternoon: 'Απογευματινό',
    slept: 'Κοιμήθηκε',
    comments: 'Σχόλια',
    comments_placeholder: 'Σημειώσεις για τη μέρα του παιδιού…',
    saved: 'Ημερήσιο ημερολόγιο αποθηκεύτηκε για {{name}}',
  },
  attendance: {
    title: 'Ημερήσιο Μητρώο',
    subtitle: 'Καταγραφή ημερήσιων αφίξεων και αναχωρήσεων',
    date: 'Ημερομηνία',
    class: 'Τάξη',
    all_classes: 'Όλες οι τάξεις',
    department: 'Τμήμα',
    all_departments: 'Όλα τα τμήματα',
    search_students: 'Αναζήτηση μαθητών…',
    arrived_stat: 'ήρθαν',
    departed_stat: 'έφυγαν',
    arrival: 'Άφιξη',
    departure: 'Αναχώρηση',
    log_arrival: 'Καταγραφη Αφιξης',
    log_departure: 'Καταγραφη Αναχωρησης',
    log_arrival_note: 'Καταγραφη Αφιξης με σημειωση',
    log_departure_note: 'Καταγραφη Αναχωρησης με σημειωση',
    undo_arrival: 'Κλικ × για αναίρεση άφιξης',
    undo_departure: 'Κλικ × για αναίρεση αναχώρησης',
    chip_arrived: 'Ήρθε',
    chip_departed: 'Έφυγε',
    chip_not_arrived: 'Δεν ήρθε',
    no_match: 'Δεν βρέθηκαν μαθητές που να ταιριάζουν',
    no_students: 'Δεν βρέθηκαν μαθητές',
    log_for: 'Καταγραφή για {{date}}',
    no_records: 'Δεν υπάρχουν εγγραφές για αυτή την ημερομηνία',
    time: 'Ώρα',
    notes: 'Σημειώσεις',
    notes_placeholder: 'π.χ. Ο παππούς παρέλαβε το παιδί',
    save: 'Αποθηκευση',
    saving: 'Αποθηκευση…',
    cancel: 'Ακυρωση',
    remove: 'Αφαιρεση',
    arrival_logged: 'Άφιξη καταγράφηκε για {{name}}',
    departure_logged: 'Αναχώρηση καταγράφηκε για {{name}}',
    absent_logged: '{{name}} σημειώθηκε ως απών',
    students_header: 'Μαθητές ({{count}})',
    prev_day: 'Προηγούμενη μέρα',
    next_day: 'Επόμενη μέρα',
    future_locked: 'Αυτή είναι μελλοντική ημερομηνία — το μητρώο είναι μόνο για ανάγνωση.',
    chip_absent: 'Δεν θα έρθει',
    log_absent: 'Σημανση ως απων σημερα',
    undo_absent: 'Κλικ × για αναίρεση απουσίας',
    no_log: 'Δεν υπάρχει καταχώρηση ημερήσιου ημερολογίου για αυτή την ημερομηνία',
    view_profile: 'Προβολή Προφίλ Μαθητή',
  },
  food: {
    title: 'Μενού Φαγητού',
    subtitle: 'Μηνιαίος σχεδιασμός γευμάτων ανά τάξη',
    class: 'Τάξη',
    copy_month: 'Αντιγραφη Απο Μηνα',
    copy_tooltip: 'Αντιγράψτε το μενού άλλου μήνα σε αυτόν τον μήνα',
    show_weekends: 'Εμφάνιση Σαββατοκύριακου',
    breakfast: 'Πρωινό',
    lunch: 'Μεσημεριανό',
    afternoon: 'Απογευματινό',
    edit_meals: 'Επεξεργασια γευματων',
    save: 'Αποθηκευση',
    saving: 'Αποθηκευση…',
    cancel: 'Ακυρωση',
    copy: 'Αντιγραφη',
    copying: 'Αντιγραφη…',
    copy_dialog_title: 'Αντιγραφή μενού σε {{month}} {{year}}',
    copy_dialog_body: 'Επιλέξτε τον μήνα προέλευσης. Τα υπάρχοντα γεύματα σε {{month}} {{year}} θα αντικατασταθούν.',
    copy_class_label: 'Τάξη αντιγραφής',
    copy_all_classes: 'Όλες οι τάξεις',
    month_label: 'Μήνας',
    year_label: 'Έτος',
    copied_message: 'Αντιγράφηκαν {{count}} εγγραφές γευμάτων στο {{month}} {{year}}',
    copy_empty_source: 'Ο μήνας προέλευσης δεν έχει εγγραφές γευμάτων για αντιγραφή.',
    copy_failed: 'Αποτυχία αντιγραφής γευμάτων. Παρακαλώ δοκιμάστε ξανά.',
    also_apply_to: 'Εφαρμογή και σε άλλες τάξεις',
    no_extra_classes: 'Μόνο αυτή η τάξη',
    clear_month: 'Καθαρισμός Μήνα',
    clear_tooltip: 'Διαγραφή όλων των γευμάτων αυτού του μήνα',
    clear_dialog_title: 'Καθαρισμός {{month}} {{year}};',
    clear_dialog_body: 'Αυτή η ενέργεια θα διαγράψει μόνιμα όλα τα γεύματα του {{month}} {{year}}. Η ενέργεια δεν μπορεί να αναιρεθεί.',
    clear_confirm: 'Καθαρισμός',
    clearing: 'Διαγραφή…',
    cleared_message: 'Όλα τα γεύματα για {{month}} {{year}} διαγράφηκαν.',
    clear_failed: 'Αποτυχία διαγραφής γευμάτων. Παρακαλώ δοκιμάστε ξανά.',
    export_week: 'Εκτύπωση Εβδομάδας',
    export_week_tooltip: 'Εκτύπωση εβδομαδιαίου πλάνου γευμάτων',
    export_month: 'Εκτύπωση Μήνα',
    export_month_tooltip: 'Εκτύπωση μηνιαίου πλάνου γευμάτων',
    pdf_daily_title: 'Ημερήσια Αναφορά Φαγητού',
    pdf_week_title: 'Εβδομαδιαίο Πλάνο Γευμάτων',
    pdf_month_title: 'Μηνιαίο Πλάνο Γευμάτων',
    pdf_class: 'Τάξη',
    pdf_departments: 'Τμήματα',
    pdf_no_meals: 'Δεν υπάρχουν προγραμματισμένα γεύματα',
    pdf_day: 'Ημέρα',
    months: {
      0: 'Ιανουάριος', 1: 'Φεβρουάριος', 2: 'Μάρτιος', 3: 'Απρίλιος',
      4: 'Μάιος', 5: 'Ιούνιος', 6: 'Ιούλιος', 7: 'Αύγουστος',
      8: 'Σεπτέμβριος', 9: 'Οκτώβριος', 10: 'Νοέμβριος', 11: 'Δεκέμβριος',
    },
    days: {
      mon: 'Δευ', tue: 'Τρι', wed: 'Τετ', thu: 'Πεμ',
      fri: 'Παρ', sat: 'Σαβ', sun: 'Κυρ',
    },
  },
  school: {
    title: 'Ρυθμίσεις Σχολείου',
    subtitle: 'Διαχειριστείτε τα στοιχεία και την τοποθεσία του σχολείου',
    save_changes: 'Αποθηκευση Αλλαγων',
    saving: 'Αποθηκευση…',
    general_info: 'Γενικές Πληροφορίες',
    school_name: 'Όνομα Σχολείου',
    address: 'Διεύθυνση',
    email: 'Email',
    website: 'Ιστοσελίδα',
    phone: 'Τηλέφωνο',
    mobile: 'Κινητό Τηλέφωνο',
    location: 'Τοποθεσία',
    location_hint: 'Κάντε κλικ στον χάρτη για να ορίσετε την τοποθεσία του σχολείου, ή εισάγετε συντεταγμένες χειροκίνητα.',
    latitude: 'Γεωγραφικό Πλάτος',
    longitude: 'Γεωγραφικό Μήκος',
    saved: 'Τα στοιχεία του σχολείου αποθηκεύτηκαν',
    save_failed: 'Αποτυχία αποθήκευσης στοιχείων σχολείου',
    route_replay_section: 'Επανάληψη Διαδρομής',
    route_replay_label: 'Ενεργοποίηση Επανάληψης Διαδρομής',
    route_replay_hint: 'Όταν είναι ενεργό, τα σημεία GPS καταγράφονται κατά τη διάρκεια ενεργών διαδρομών και μπορούν να αναπαραχθούν στον χάρτη για τις τελευταίες 7 ημέρες.',
  },
  parent_today: {
    today_chip: 'Σήμερα',
    no_data: 'Δεν υπάρχουν δεδομένα για αυτή την ημέρα.',
    load_error: 'Αποτυχία φόρτωσης ημερήσιων καταχωρίσεων',
    absent: 'Απών',
    no_bus: 'Χωρίς λεωφορείο',
    manage_absences: 'Διαχείριση Απουσιών',
    arrival: 'Άφιξη',
    departure: 'Αναχώρηση',
    meals: 'Γεύματα',
    breakfast: 'Πρωινό',
    lunch: 'Μεσημεριανό',
    snack: 'Σνακ',
    nap: 'Ύπνος',
  },
  reports: {
    title: 'Αναφορές',
    subtitle: 'Ημερήσιες παρουσίες & ατομικές αναφορές',
    tab_daily: 'Ημερήσια Αναφορά',
    tab_child: 'Ατομική Αναφορά',
    tab_routes: 'Διαδρομές',
    tab_birthdays: 'Γενέθλια',
    birthday_notification: '🎂 {{count}} γενέθλια σήμερα! Κάντε κλικ.',
    birthday_notification_plural: '🎂 {{count}} γενέθλια σήμερα! Κάντε κλικ.',
    birthday_tab_title: 'Μαθητές με γενέθλια στις',
    birthday_no_birthdays: 'Δεν υπάρχουν γενέθλια σήμερα.',
    birthday_col_name: 'Όνομα',
    birthday_col_class: 'Τάξη',
    birthday_col_department: 'Τμήμα',
    birthday_col_dob: 'Ημερομηνία Γέννησης',
    date_label: 'Ημερομηνία',
    export_pdf: 'Εξαγωγή PDF',
    export_tooltip: 'Εξαγωγή σε PDF',
    all_classes: 'Όλες οι τάξεις',
    total: '{{count}} σύνολο',
    stat_arrived: '{{count}} ήρθαν',
    stat_absent: '{{count}} απόντες',
    stat_pending: '{{count}} δεν ήρθαν ακόμα',
    col_child: 'Μαθητής',
    col_status: 'Κατάσταση',
    col_arrival: 'Άφιξη',
    col_departure: 'Αναχώρηση',
    col_breakfast: 'Πρωινό',
    col_lunch: 'Μεσημεριανό',
    col_afternoon: 'Απογευματινό',
    col_slept: 'Κοιμήθηκε',
    col_notes: 'Σημειώσεις',
    col_date: 'Ημερομηνία',
    col_day: 'Ημέρα',
    col_comments: 'Σχόλια',
    col_in: 'Μέσα',
    col_out: 'Έξω',
    n_children: '{{count}} παιδιά',
    no_students: 'Δεν βρέθηκαν μαθητές.',
    status_absent: 'Απών',
    status_in_out: 'Μέσα / Έξω',
    status_arrived: 'Ήρθε',
    status_departed: 'Έφυγε',
    select_child: 'Επιλογή παιδιού',
    weekly: 'Εβδομαδιαία',
    monthly: 'Μηνιαία',
    select_child_hint: 'Επιλέξτε παιδί παραπάνω για να δείτε την αναφορά.',
    days_present: '{{count}} / {{total}} ημέρες παρών',
    pdf_daily_title: 'Ημερήσια Αναφορά Παρουσιών',
    pdf_date: 'Ημερομηνία:',
    pdf_school: 'Σχολείο:',
    pdf_child_title: 'Ατομική Αναφορά',
    pdf_child: 'Μαθητής:',
    pdf_class: 'Τάξη:',
    pdf_period: 'Περίοδος:',
    pdf_status_absent: 'Απών',
    pdf_status_in_out: 'Μέσα/Έξω',
    pdf_status_arrived: 'Ήρθε',
    replay_btn: 'Αναπαραγωγή',
    replay_title: 'Επανάληψη Διαδρομής',
    replay_no_points: 'Δεν υπάρχει καταγεγραμμένο ίχνος GPS για αυτή τη διαδρομή.',
    replay_loading: 'Φόρτωση ίχνους…',
    replay_play: 'Αναπαραγωγή',
    replay_pause: 'Παύση',
    replay_reset: 'Επαναφορά',
    replay_points_count: '{{count}} σημεία GPS',
    replay_delete: 'Διαγραφή Σημείων',
    replay_delete_confirm: 'Επιβεβαίωση Διαγραφής;',
  },
  messages: {
    title: 'Μηνύματα',
    compose: 'Νέο Μήνυμα',
    send: 'Αποστολή',
    sending: 'Αποστολή…',
    no_messages: 'Δεν έχουν σταλεί μηνύματα',
    no_subject: '(Χωρίς θέμα)',
    read: 'διαβάστηκε',
    recipients: 'παραλήπτες',
    recipients_list: 'Παραλήπτες',
    children_attendance: 'Παρουσία Παιδιών',
    read_label: 'Διαβάστηκε',
    unread_label: 'Αδιάβαστο',
    send_to: 'Αποστολή σε',
    target_all: 'Όλοι οι γονείς',
    target_class: 'Γονείς τάξης',
    target_department: 'Γονείς τμήματος',
    target_children: 'Γονείς επιλεγμένων μαθητών',
    target_all_routes: 'Γονείς όλων των διαδρομών',
    target_route: 'Γονείς διαδρομής',
    pick_class: 'Επιλογή τάξης',
    pick_department: 'Επιλογή τμήματος',
    pick_route: 'Επιλογή διαδρομής',
    pick_children: 'Προσθήκη μαθητών',
    search_child: 'Αναζήτηση μαθητή…',
    selected: 'επιλεγμένοι',
    subject: 'Θέμα',
    message_body: 'Μήνυμα',
    invitation: 'Πρόσκληση',
    invitation_toggle: 'Αίτημα RSVP',
    invitation_hint: 'Οι παραλήπτες μπορούν να απαντήσουν Ναι / Όχι / Ίσως',
    rsvp_yes: 'Ναι',
    rsvp_no: 'Όχι',
    rsvp_maybe: 'Ίσως',
    rsvp_none: 'Χωρίς απάντηση',
    tab_sent: 'Απεσταλμένα',
    tab_received: 'Ληφθέντα',
    no_messages_received: 'Δεν λήφθηκαν μηνύματα',
    reply: 'Απάντηση',
  },
  send_toast: {
    button_tooltip: 'Αποστολή Ειδοποίησης',
    title: 'Αποστολή Ειδοποίησης',
    recipients: 'Παραλήπτες',
    message: 'Μήνυμα',
    severity: 'Τύπος',
    severity_info: 'Πληροφορία',
    severity_success: 'Επιτυχία',
    severity_warning: 'Προειδοποίηση',
    severity_error: 'Σφάλμα',
    send: 'Αποστολή',
    cancel: 'Ακύρωση',
    sent_ok: 'Εστάλη σε {{count}} χρήστη/ες.',
    error: 'Αποτυχία αποστολής. Δοκιμάστε ξανά.',
  },
  map: {
    loading: 'Φόρτωση…',
    show_children: 'Εμφάνιση Παιδιών',
    hide_children: 'Απόκρυψη Παιδιών',
    children_stops: '{{children}} παιδιά · {{stops}} στάσεις',
    show_route: 'Εμφάνιση διαδρομής',
    none: 'Καμία',
    to_school_chip: '→ Σχολείο',
    from_school_chip: '← Σπίτι',
    stop_of: 'Στάση {{index}} από {{total}} · {{route}}',
    picked_up: 'παρέλαβε',
    dropped_off: 'παρέδωσε',
    route_started: '{{driver}} ξεκίνησε τη διαδρομή {{route}}',
    route_stopped: '{{driver}} σταμάτησε τη διαδρομή {{route}}',
    route_finished: '{{driver}} ολοκλήρωσε τη διαδρομή {{route}}',
    route_started_alert_title: 'Διαδρομή Ξεκίνησε',
    route_started_alert_ok: 'Μετάβαση στον χάρτη',
    delay_set: '{{driver}} ανέφερε καθυστέρηση {{minutes}} λεπτών',
    early_set: '{{driver}} θα φτάσει {{minutes}} λεπτά νωρίτερα',
    show_all_buses: 'Τελευταίες Θέσεις Λεωφορείων',
    hide_all_buses: 'Απόκρυψη Όλων',
    auto_zoom: 'Αυτόματη Εστίαση',
    last_known: 'Τελευταία γνωστή θέση',
    absent_today: 'Απών σήμερα',
    show_route_children: 'Παιδιά Ενεργών Διαδρομών',
    hide_route_children: 'Απόκρυψη Παιδιών',
    picked_up_at: 'Παρελήφθη στις {{time}}',
    dropped_off_at: 'Παραδόθηκε στις {{time}}',
    status_dropped_off: 'Παραδόθηκε',
    next_stop: 'Επόμενη στάση',
    pending_pickup: 'Εκκρεμεί παραλαβή',
    pending_dropoff: 'Εκκρεμεί παράδοση',
    status_skipped: 'Παραλείφθηκε',
    status_picked_up: 'Επιβιβάστηκε',
    dashboard_active_routes: 'Ενεργές διαδρομές',
    dashboard_picked_up: 'Επιβιβάστηκαν',
    dashboard_skipped: 'Παραλείφθηκαν',
    dashboard_pending: 'Εκκρεμούν',
    dashboard_no_active: 'Δεν υπάρχουν ενεργές διαδρομές αυτή τη στιγμή',
    active_route_filter: 'Ενεργή Διαδρομή',
    all_active_routes: 'Όλες οι ενεργές',
    active_routes_widget: 'Ενεργές Διαδρομές',
    close_route: 'Κλείσιμο Διαδρομής',
    close_route_confirm: 'Αναγκαστικό κλείσιμο αυτής της διαδρομής;',
    route_closed: 'Η διαδρομή έκλεισε',
    close_route_failed: 'Αποτυχία κλεισίματος διαδρομής',
    show_active_routes_panel: 'Ενεργές Διαδρομές',
    message_driver: 'Μήνυμα οδηγού',
    message_driver_title: 'Αποστολή μηνύματος στον οδηγό',
    message_driver_placeholder: 'Πληκτρολογήστε το μήνυμά σας…',
    message_driver_send: 'Αποστολή',
    message_driver_sent: 'Το μήνυμα στάλθηκε',
    message_driver_failed: 'Αποτυχία αποστολής μηνύματος',
    route_prefix: 'Διαδρομή',
    status_finished: 'Ολοκληρώθηκε',
    status_stopped: 'Σταμάτησε',
    early_min: 'Νωρίτερα {{minutes}} λεπτά',
    delayed_min: 'Καθυστέρηση {{minutes}} λεπτά',
    updated_at: 'Ενημερώθηκε',
  },
  routes: {
    title: '\u0394\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ad\u03c2',
    subtitle: '\u0394\u03b9\u03b1\u03c7\u03b5\u03af\u03c1\u03b9\u03c3\u03b7 \u03b4\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ce\u03bd \u03ba\u03b1\u03b9 \u03c3\u03c4\u03ac\u03c3\u03b5\u03c9\u03bd',
    loading: '\u03a6\u03cc\u03c1\u03c4\u03c9\u03c3\u03b7 \u03b4\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ce\u03bd\u2026',
    add: '\u039d\u03ad\u03b1 \u0394\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ae',
    no_routes: '\u0394\u03b5\u03bd \u03c5\u03c0\u03ac\u03c1\u03c7\u03bf\u03c5\u03bd \u03b4\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ad\u03c2. \u0394\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03c1\u03ce\u03c4\u03b7 \u03c3\u03b1\u03c2.',
    to_school: '\u03a0\u03c1\u03bf\u03c2 \u03c3\u03c7\u03bf\u03bb\u03b5\u03af\u03bf',
    from_school: '\u0391\u03c0\u03cc \u03c3\u03c7\u03bf\u03bb\u03b5\u03af\u03bf',
    one_time: '\u039c\u03af\u03b1 \u03c6\u03bf\u03c1\u03ac',
    stops: '\u03c3\u03c4\u03ac\u03c3\u03b5\u03b9\u03c2',
    stop_order: '\u03a3\u03b5\u03b9\u03c1\u03ac \u03a3\u03c4\u03ac\u03c3\u03b5\u03c9\u03bd',
    edit: '\u0395\u03c0\u03b5\u03be\u03b5\u03c1\u03b3\u03b1\u03c3\u03af\u03b1 \u03b4\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ae\u03c2',
    rename: '\u039c\u03b5\u03c4\u03bf\u03bd\u03bf\u03bc\u03b1\u03c3\u03af\u03b1',
    delete: '\u0394\u03b9\u03b1\u03b3\u03c1\u03b1\u03c6\u03ae',
    delete_confirm: '\u0395\u03af\u03c3\u03c4\u03b5 \u03c3\u03af\u03b3\u03bf\u03c5\u03c1\u03bf\u03b9 \u03cc\u03c4\u03b9 \u03b8\u03ad\u03bb\u03b5\u03c4\u03b5 \u03bd\u03b1 \u03b4\u03b9\u03b1\u03b3\u03c1\u03ac\u03c8\u03b5\u03c4\u03b5 \u03c4\u03bf "{{name}}"; \u0394\u03b5\u03bd \u03bc\u03c0\u03bf\u03c1\u03b5\u03af \u03bd\u03b1 \u03b1\u03bd\u03b1\u03b9\u03c1\u03b5\u03b8\u03b5\u03af.',
    new_route: '\u039d\u03ad\u03b1 \u0394\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ae',
    edit_route: '\u0395\u03c0\u03b5\u03be\u03b5\u03c1\u03b3\u03b1\u03c3\u03af\u03b1 \u0394\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ae\u03c2',
    route_name: '\u038c\u03bd\u03bf\u03bc\u03b1 \u0394\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ae\u03c2',
    available_children: '\u0394\u03b9\u03b1\u03b8\u03ad\u03c3\u03b9\u03bc\u03b1 \u03a0\u03b1\u03b9\u03b4\u03b9\u03ac',
    filter_class: '\u03a4\u03ac\u03be\u03b7',
    filter_dept: '\u03a4\u03bc\u03ae\u03bc\u03b1',
    all_classes: '\u038c\u03bb\u03b5\u03c2 \u03bf\u03b9 \u03c4\u03ac\u03be\u03b5\u03b9\u03c2',
    all_depts: '\u038c\u03bb\u03b1 \u03c4\u03b1 \u03c4\u03bc\u03ae\u03bc\u03b1\u03c4\u03b1',
    no_available_children: '\u0394\u03b5\u03bd \u03c5\u03c0\u03ac\u03c1\u03c7\u03bf\u03c5\u03bd \u03b4\u03b9\u03b1\u03b8\u03ad\u03c3\u03b9\u03bc\u03b1 \u03c0\u03b1\u03b9\u03b4\u03b9\u03ac \u03b3\u03b9\u03b1 \u03b1\u03c5\u03c4\u03cc \u03c4\u03bf\u03bd \u03c4\u03cd\u03c0\u03bf \u03b4\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ae\u03c2.',
    route_stops: '\u03a3\u03c4\u03ac\u03c3\u03b5\u03b9\u03c2 \u0394\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ae\u03c2',
    select_stops_hint: '\u039a\u03ac\u03bd\u03c4\u03b5 \u03ba\u03bb\u03b9\u03ba \u03c3\u03b5 \u03b4\u03b9\u03b5\u03c5\u03b8\u03cd\u03bd\u03c3\u03b5\u03b9\u03c2 \u03ae markers \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03c0\u03c1\u03bf\u03c3\u03b8\u03ad\u03c3\u03b5\u03c4\u03b5 \u03c3\u03c4\u03ac\u03c3\u03b5\u03b9\u03c2.',
    selected: '\u03a0\u03c1\u03bf\u03c3\u03c4\u03ad\u03b8\u03b7\u03ba\u03b5',
    added: '\u03a0\u03c1\u03bf\u03c3\u03c4\u03ad\u03b8\u03b7\u03ba\u03b5',
    add_stop: '\u03c0\u03c1\u03bf\u03c3\u03b8\u03ae\u03ba\u03b7 \u03c3\u03c4\u03ac\u03c3\u03b7\u03c2',
    available: '\u03b4\u03b9\u03b1\u03b8\u03ad\u03c3\u03b9\u03bc\u03b1',
    map_hint: '\u03ba\u03bb\u03b9\u03ba \u03c3\u03b5 markers \u03b3\u03b9\u03b1 \u03c0\u03c1\u03bf\u03c3\u03b8\u03ae\u03ba\u03b7/\u03b1\u03c6\u03b1\u03af\u03c1\u03b5\u03c3\u03b7',
    clear_filter: '\u039a\u03b1\u03b8\u03b1\u03c1\u03b9\u03c3\u03bc\u03cc\u03c2',
    no_children_in_filter: '\u0394\u03b5\u03bd \u03c5\u03c0\u03ac\u03c1\u03c7\u03bf\u03c5\u03bd \u03c0\u03b1\u03b9\u03b4\u03b9\u03ac \u03b3\u03b9\u03b1 \u03b1\u03c5\u03c4\u03cc \u03c4\u03bf \u03c6\u03af\u03bb\u03c4\u03c1\u03bf.',
    created: '\u0397 \u03b4\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ae \u03b4\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03ae\u03b8\u03b7\u03ba\u03b5 \u03b5\u03c0\u03b9\u03c4\u03c5\u03c7\u03ce\u03c2',
    updated: '\u0397 \u03b4\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ae \u03b5\u03bd\u03b7\u03bc\u03b5\u03c1\u03ce\u03b8\u03b7\u03ba\u03b5 \u03b5\u03c0\u03b9\u03c4\u03c5\u03c7\u03ce\u03c2',
    renamed: '\u0397 \u03b4\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ae \u03bc\u03b5\u03c4\u03bf\u03bd\u03bf\u03bc\u03ac\u03c3\u03c4\u03b7\u03ba\u03b5',
    deleted: '\u0397 \u03b4\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ae \u03b4\u03b9\u03b1\u03b3\u03c1\u03ac\u03c6\u03b7\u03ba\u03b5',
    save_failed: '\u0391\u03c0\u03bf\u03c4\u03c5\u03c7\u03af\u03b1 \u03b1\u03c0\u03bf\u03b8\u03ae\u03ba\u03b5\u03c5\u03c3\u03b7\u03c2 \u03b4\u03b9\u03b1\u03b4\u03c1\u03bf\u03bc\u03ae\u03c2',
    save_requires_name: 'Εισάγετε όνομα διαδρομής για αποθήκευση',
    save_requires_stops: 'Προσθέστε τουλάχιστον μία στάση για αποθήκευση',
    save_requires_name_and_stops: 'Εισάγετε όνομα και προσθέστε τουλάχιστον μία στάση',
    tab_routes: 'Διαδρομές',
    tab_pending: 'Εκκρεμείς',
    pending_empty: 'Όλα τα παιδιά έχουν ανατεθεί σε διαδρομές.',
    pending_to_school: 'Χρειάζεται δρομολόγιο προς σχολείο',
    pending_from_school: 'Χρειάζεται δρομολόγιο από σχολείο',
    no_address_warning: 'Δεν έχει διεύθυνση — προσθέστε διεύθυνση παραλαβής πρώτα',
    optimize: 'Βελτιστοποίηση',
    optimizing: 'Βελτιστοποίηση…',
    optimize_applied: 'Εφαρμόστηκε βέλτιστη σειρά',
    optimize_undo: 'Αναίρεση',
    optimize_error: 'Αδυναμία βελτιστοποίησης — η υπηρεσία δρομολόγησης δεν είναι διαθέσιμη',
    optimize_too_few: 'Προσθέστε τουλάχιστον 2 στάσεις για βελτιστοποίηση',
    depot_label: 'Αφετηρία Λεωφορείου',
    depot_not_set: 'Μη ορισμένη (προαιρετική)',
    depot_set_on_map: 'Ορισμός στον χάρτη',
    depot_cancel_pick: 'Ακύρωση',
    depot_picking_hint: 'Κάντε κλικ στον χάρτη για να ορίσετε την αφετηρία',
    show_road_path: 'Εμφάνιση Διαδρομής',
    hide_road_path: 'Απόκρυψη Διαδρομής',
    road_path_loading: 'Φόρτωση…',
    road_path_total: 'συνολική διαδρομή',
    start_time: 'Ώρα Εκκίνησης',
    start_time_hint: 'Προαιρετική – όταν οριστεί, εμφανίζεται εκτιμώμενη ώρα άφιξης ανά στάση',
  },
  absences: {
    title: 'Απουσίες Λεωφορείου',
    manage: 'Διαχείριση Απουσιών',
    for: 'Απουσίες για {{name}}',
    no_absences: 'Δεν υπάρχουν προγραμματισμένες απουσίες.',
    add_absence: 'Προσθήκη Απουσίας',
    date_label: 'Ημερομηνία',
    reason_label: 'Αιτία (προαιρετικό)',
    reason_placeholder: 'π.χ. άρρωστος, εκδρομή…',
    absent_today: 'Απών σήμερα',
    bus_absent_today: 'Δεν έρχεται με λεωφορείο',
    save: 'Προσθήκη',
    delete_confirm: 'Αφαίρεση αυτής της απουσίας;',
    added: 'Η απουσία προστέθηκε',
    removed: 'Η απουσία αφαιρέθηκε',
    error: 'Αποτυχία αποθήκευσης απουσίας',
    type_label: 'Τύπος απουσίας',
    type_full: 'Απών από σχολείο',
    type_bus: 'Μόνο από λεωφορείο',
    routes_label: 'Απών από δρομολόγια',
    skip_to_school: 'Πρωί (προς σχολείο)',
    skip_from_school: 'Απόγευμα (από σχολείο)',
    chip_full: 'Σχολείο',
    chip_bus: 'Λεωφορείο',
  },
  common: {
    save: '\u0391\u03c0\u03bf\u03b8\u03b7\u03ba\u03b5\u03c5\u03c3\u03b7',
    saving: 'Αποθηκευση…',
    cancel: 'Ακυρωση',
    ok: 'ΟΚ',
    yes: 'Ναι',
    no: 'Οχι',
    first_name: 'Όνομα',
    last_name: 'Επώνυμο',
    email: 'Email',
    phone_number: 'Τηλέφωνο',
    actions: 'Ενέργειες',
    school: 'Σχολείο:',
    logged_in: 'Έχετε συνδεθεί στην αρχική σελίδα!',
    email_required: 'Το email είναι υποχρεωτικό.',
    email_invalid: 'Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email.',
    first_name_required: 'Το όνομα είναι υποχρεωτικό.',
    last_name_required: 'Το επώνυμο είναι υποχρεωτικό.',
    phone_number_required: 'Ο αριθμός τηλεφώνου είναι υποχρεωτικός.',
    phone_number_invalid: 'Ο αριθμός τηλεφώνου πρέπει να περιέχει μόνο ψηφία (έως 14).',
    phone: 'Τηλέφωνο',
    status: 'Κατάσταση',
    edit: 'Επεξεργασια',
    delete: 'Διαγραφη',
    restore: 'Επαναφορά',
    app_version: 'Έκδοση {{version}}',
    network_error: 'Σφάλμα δικτύου. Παρακαλώ ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.',
    close: 'Κλείσιμο',
    no_rows: 'Δεν υπάρχουν εγγραφές',
    rows_per_page: 'Γραμμές ανά σελίδα:',
    select_all: 'Επιλογή όλων',
    n_selected: '{{count}} επιλεγμένα',
    delete_n: 'Διαγραφή ({{count}})',
  },
  driver_map: {
    select_route: 'Επιλέξτε διαδρομή για να ξεκινήσετε',
    no_routes: 'Δεν υπάρχουν διαδρομές για το σχολείο σας.',
    stops_active: '{{count}} στάσεις · {{active}} ενεργές',
    stops_count: '{{count}} στάσεις',
    to_school: 'Προς Σχολείο',
    from_school: 'Από Σχολείο',
    route_label: 'Διαδρομή',
    picked_count: '{{count}}/{{total}} επιβιβάστηκαν',
    delay_btn: 'Καθυστέρηση / Νωρίτερα',
    route_started: 'Η διαδρομή ξεκίνησε',
    route_paused: 'Η διαδρομή ακυρώθηκε',
    route_finished: 'Η διαδρομή ολοκληρώθηκε!',
    child_picked_up: '{{name}} επιβιβάστηκε',
    pickup_failed: 'Αποτυχία καταγραφής επιβίβασης',
    delay_reported: 'Καθυστέρηση {{minutes}} λεπτών αναφέρθηκε',
    early_reported: 'Έγκαιρη άφιξη {{minutes}} λεπτών αναφέρθηκε',
    report_delay_title: 'Καθυστέρηση / Νωρίτερη Άφιξη',
    early_section: 'Νωρίτερα',
    delay_section: 'Καθυστέρηση',
    first_stop: 'Πρώτη στάση',
    start_route: 'Εκκίνηση Διαδρομής',
    next_stop: 'Επόμενη Στάση',
    picked_up_btn: 'Επιβιβάστηκε',
    dropped_off_btn: 'Αποβιβάστηκε',
    pause: 'Ακύρωση',
    finish_route: 'Ολοκλήρωση Διαδρομής',
    all_done: 'Όλες οι στάσεις ολοκληρώθηκαν!',
    status_finished: 'Διαδρομή ολοκληρώθηκε',
    status_paused: 'Διαδρομή ακυρώθηκε',
    resume_route: 'Συνέχεια Διαδρομής',
    report_delay: 'Αναφορά Καθυστέρησης',
    min: 'λεπ.',
    absent: 'Απών',
    status_picked_up: 'Επιβιβάστηκε',
    upcoming: 'Επόμενος',
    skip_btn: 'Παράλειψη',
    skip_confirm_title: 'Παράλειψη Παιδιού;',
    skip_confirm_msg: 'Παράλειψη {{name}} και μετάβαση στην επόμενη στάση;',
    child_skipped: '{{name}} παραλείφθηκε',
    skip_failed: 'Αποτυχία καταγραφής παράλειψης',
    status_skipped: 'Παραλείφθηκε',
    child_marked_absent: '{{name}} δηλώθηκε απών — η στάση αφαιρέθηκε από τη διαδρομή σας',
    geo_denied: 'Δεν επιτράπηκε πρόσβαση στη θέση. Το σχολείο δεν βλέπει τη διαδρομή σας.',
    geo_unavailable: 'Δεν είναι διαθέσιμη η θέση. Ελέγξτε τις ρυθμίσεις της συσκευής σας.',
    geo_no_support: 'Το πρόγραμμα περιήγησής σας δεν υποστηρίζει εντοπισμό τοποθεσίας.',
    geo_fix_chrome: 'Κάντε κλικ στο εικονίδιο κλειδαριάς στη γραμμή διεύθυνσης → Τοποθεσία → Να επιτρέπεται, και μετά φορτώστε ξανά.',
    geo_fix_edge: 'Κάντε κλικ στο εικονίδιο κλειδαριάς στη γραμμή διεύθυνσης → Τοποθεσία → Να επιτρέπεται, και μετά φορτώστε ξανά.',
    geo_fix_firefox: 'Κάντε κλικ στο εικονίδιο κλειδαριάς → διαγράψτε την αποκλεισμένη άδεια Τοποθεσίας, και μετά φορτώστε ξανά.',
    geo_fix_safari_ios: 'Πηγαίνετε στις Ρυθμίσεις iOS → Απόρρητο → Υπηρεσίες τοποθεσίας → Safari → Κατά τη χρήση.',
    geo_fix_safari_mac: 'Στο Safari → Ρυθμίσεις → Ιστότοποι → Τοποθεσία → επιτρέψτε αυτόν τον ιστότοπο, και μετά φορτώστε ξανά.',
    geo_fix_samsung: 'Πατήστε ⋮ → Ρυθμίσεις → Sites and downloads → Τοποθεσία → επιτρέψτε αυτόν τον ιστότοπο, και μετά φορτώστε ξανά.',
    geo_fix_other: 'Ανοίξτε τις ρυθμίσεις ιστότοπου του περιηγητή σας και επιτρέψτε την Τοποθεσία για αυτή τη σελίδα, και μετά φορτώστε ξανά.',
    geo_reload: 'Επαναφόρτωση',
    cancel_route_title: 'Ακύρωση Διαδρομής;',
    cancel_reason_traffic: 'Κυκλοφοριακό / ατύχημα',
    cancel_reason_breakdown: 'Βλάβη οχήματος',
    cancel_reason_driver: 'Πρόβλημα οδηγού',
    cancel_reason_other: 'Άλλο',
    confirm_cancel: 'Ακύρωση Διαδρομής',
    progress_restored: 'Επαναφορά προόδου — {{done}} στάσεις ήδη ολοκληρώθηκαν',
    finish_pending_title: 'Ολοκλήρωση με εκκρεμείς στάσεις;',
    finish_pending_msg: '{{count}} παιδί/παιδιά δεν έχουν ακόμα επιβιβαστεί ή παραληφθεί. Θέλετε σίγουρα να ολοκληρώσετε τη διαδρομή;',
    finish_pending_confirm: 'Ολοκλήρωση Ούτως ή Άλλως',
    nav_route_toggle: 'Γραμμή διαδρομής',
    nav_route_no_location: 'Η τοποθεσία δεν είναι διαθέσιμη — ενεργοποιήστε GPS και δοκιμάστε ξανά',
    nav_route_unavailable: 'Η υπηρεσία πλοήγησης δεν είναι διαθέσιμη',
    recenter: 'Επαναφορά χάρτη',
    route_active_badge: 'Ενεργή',
    route_in_use_badge: 'Σε Χρήση',
    route_taken_error: 'Αυτή η διαδρομή εκτελείται ήδη από άλλον οδηγό.',
    already_active_error: 'Έχετε ήδη ενεργή διαδρομή. Ολοκληρώστε την πριν ξεκινήσετε άλλη.',
    route_complete_title: 'Διαδρομή Ολοκληρώθηκε!',
    back_to_routes: 'Επιστροφή στις Διαδρομές',
    report_picked_up: 'Επιβιβάστηκε',
    report_dropped_off: 'Αποβιβάστηκε',
    report_skipped: 'Παραλείφθηκε',
    report_absent: 'Απών',
    report_not_reached: 'Δεν εξυπηρετήθηκε',
    arrived_at_stop: 'Φτάσατε στη στάση!',
    dismiss: 'Κλείσιμο',
    absent_popup_title: 'Απουσίες σε αυτή τη διαδρομή σήμερα',
    absent_popup_subtitle: '{{count}} παιδί/παιδιά δεν θα παραληφθούν ή αποβιβαστούν σήμερα',
    mid_route_absence_title: 'Παιδί αφαιρέθηκε από τη διαδρομή',
    mid_route_absence_subtitle: '{{count}} παιδί/παιδιά μόλις ακυρώθηκαν από γονέα και αφαιρέθηκαν από αυτή τη διαδρομή',
    view_absences_btn: 'Προβολή απουσιών',
    manage_children_btn: 'Διαχείριση παιδιών',
    manage_children_title: 'Διαχείριση παιδιών σε αυτή τη διαδρομή',
    manage_children_subtitle: 'Αφαιρέστε ένα παιδί από τη σημερινή διαδρομή. Μια αφαίρεση που δεν έχει καταχωρηθεί χάνεται αν φύγετε από αυτή την οθόνη χωρίς να ξεκινήσετε τη διαδρομή.',
    remove_child_btn: 'Αφαίρεση',
    undo_remove_btn: 'Αναίρεση',
    simulate_route: 'Προσομοίωση Διαδρομής (Δοκιμή)',
    simulation_running: 'Η προσομοίωση εκτελείται',
    simulation_started: 'Η προσομοίωση ξεκίνησε',
    simulation_finished: 'Η προσομοίωση ολοκληρώθηκε!',
    simulation_stopped: 'Η προσομοίωση διακόπηκε',
    simulation_no_stops: 'Δεν υπάρχουν ενεργές στάσεις για προσομοίωση σε αυτή τη διαδρομή',
    wake_lock_native: 'Κλείδωμα οθόνης: εγγενές ✓',
    wake_lock_fallback_video: 'Κλείδωμα οθόνης: εναλλακτικό βίντεο ✓',
    wake_lock_unsupported: 'Κλείδωμα οθόνης: μη υποστηριζόμενο ✗',
    wake_lock_failed: 'Κλείδωμα οθόνης: απέτυχε ✗',
    wake_lock_pending: 'Κλείδωμα οθόνης: έλεγχος…',
    stop_simulation: 'Διακοπή Προσομοίωσης',
  },
  driver_settings: {
    subtitle: 'Διαχείριση προφίλ και λογαριασμού',
    role_driver: 'Οδηγός',
    current_password: 'Τρέχων κωδικός',
    password_min_length: 'Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.',
    password_change_failed: 'Αποτυχία αλλαγής κωδικού',
    save_failed: 'Αποτυχία αποθήκευσης',
    proximity_alert_label: 'Αναδυόμενο μήνυμα προσέγγισης',
    proximity_alert_desc: 'Εμφάνιση αναδυόμενου παραθύρου με κουμπί επιβεβαίωσης όταν πλησιάζετε τη στάση του επόμενου παιδιού',
    proximity_alert_sound_label: 'Ήχος προσέγγισης',
    proximity_alert_sound_desc: 'Αναπαραγωγή ήχου όταν εμφανίζεται το αναδυόμενο μήνυμα προσέγγισης',
    route_absence_popup_label: 'Αναδυόμενο απουσιών',
    route_absence_popup_desc: 'Εμφάνιση αναδυόμενου παραθύρου με τις σημερινές απουσίες όταν επιλέγετε μια διαδρομή από τη λίστα',
  },
  parent_messages_page: {
    no_subject: '(Χωρίς θέμα)',
    mark_read: 'Σήμανση ως αναγνωσμένο',
    rsvp_yes: 'Αποδοχή',
    rsvp_no: 'Απόρριψη',
    rsvp_label: 'RSVP: {{response}}',
    compose: 'Σύνταξη',
    inbox: 'Εισερχόμενα',
    sent_tab: 'Απεσταλμένα',
    empty_inbox: 'Τα εισερχόμενα σας είναι κενά.',
    no_sent: 'Δεν υπάρχουν απεσταλμένα μηνύματα.',
    compose_title: 'Νέο Μήνυμα',
    send_to_label: 'Αποστολή σε',
    send_to_school: 'Σχολείο',
    send_to_classmates: 'Γονείς από την τάξη του παιδιού μου',
    no_classmates: 'Δεν βρέθηκαν συμμαθητές.',
    subject_label: 'Θέμα',
    message_label: 'Μήνυμα',
    send_btn: 'Αποστολή',
    sent_success: 'Το μήνυμα εστάλη',
    send_failed: 'Αποτυχία αποστολής μηνύματος',
    rsvp_confirmed: 'Η αποδοχή επιβεβαιώθηκε: {{response}}',
    no_parent: 'Δεν υπάρχει εγγεγραμμένος γονέας',
    request_rsvp: 'Αίτημα RSVP',
  },
  parent_children_page: {
    no_children: 'Δεν υπάρχουν παιδιά συνδεδεμένα στο λογαριασμό σας.',
    manage_absences: 'Διαχείριση Απουσιών',
    manage_absences_for: 'Απουσίες — {{name}}',
    report_absence: 'Αναφορά Απουσίας',
    report_absence_for: 'Αναφορά Απουσίας — {{name}}',
    attendance_history: 'Ιστορικό Παρουσιών',
    from_label: 'Από',
    to_label: 'Έως',
    reason_optional: 'Αιτία (προαιρετικό)',
    report_btn: 'Προσθήκη Απουσίας',
    absence_reported: 'Απουσία αποθηκεύτηκε',
    absence_saved: 'Απουσία αποθηκεύτηκε',
    absence_failed: 'Αποτυχία αποθήκευσης απουσίας',
    absence_deleted: 'Απουσία αφαιρέθηκε',
    absent_today: 'Απών σήμερα',
    bus_absent_today: 'Δεν έρχεται με λεωφορείο',
    type_label: 'Τύπος',
    type_full: 'Απών από σχολείο',
    type_bus: 'Μόνο από λεωφορείο',
    routes_label: 'Δρομολόγια προς παράλειψη',
    skip_to_school: 'Πρωί (προς σχολείο)',
    skip_from_school: 'Απόγευμα (από σχολείο)',
    scheduled: 'Προγραμματισμένες απουσίες',
    no_scheduled: 'Δεν υπάρχουν προγραμματισμένες απουσίες.',
    by_school: 'Καταχωρήθηκε από το σχολείο',
    chip_full: 'Σχολείο',
    chip_bus: 'Λεωφορείο',
    period_7d: 'Τελευταίες 7 ημέρες',
    period_30d: 'Τελευταίες 30 ημέρες',
    period_3m: 'Τελευταίοι 3 μήνες',
    period_6m: 'Τελευταίοι 6 μήνες',
    period_1y: 'Τελευταίος χρόνος',
    stat_present_pct: 'Παρουσία %',
    stat_absences: 'Απουσίες',
    stat_avg_arrival: 'Μέση ώρα άφιξης',
    stat_avg_departure: 'Μέση ώρα αναχώρησης',
    stat_breakfasts: 'Πρωινά',
    stat_lunches: 'Μεσημεριανά',
  },
  parent_bus_tracking_page: {
    title: 'Ζωντανή Παρακολούθηση Λεωφορείου',
    no_session: 'Δεν υπάρχει ενεργή συνεδρία παρακολούθησης',
    no_session_desc: 'Το λεωφορείο δεν παρακολουθείται αυτή τη στιγμή. Η σελίδα θα ενημερωθεί αυτόματα όταν ξεκινήσει δρομολόγιο.',
    checking: 'Έλεγχος κάθε 10 δευτερόλεπτα…',
    back: 'Πίσω',
    tracking_ended: 'Η παρακολούθηση τερματίστηκε',
    session_inactive: 'Η συνεδρία δεν είναι πλέον ενεργή.',
    watch_new: 'Αναμονή για νέα συνεδρία',
    go_back: 'Επιστροφή',
    expires_in: 'Λήγει σε {{countdown}}',
    waiting_location: 'Αναμονή τοποθεσίας λεωφορείου…',
    status_child_picked_up: 'Το παιδί έχει παραληφθεί.',
    status_child_skipped: 'Ο οδηγός παρέκαμψε αυτή τη στάση.',
    status_route_stopped: 'Το δρομολόγιο έχει τελειώσει.',
    status_expired: 'Η συνεδρία παρακολούθησης έληξε.',
    status_unreachable: 'Απώλεια σύνδεσης μετά από 3 αποτυχημένες προσπάθειες.',
    status_invalid: 'Η συνεδρία παρακολούθησης δεν βρέθηκε ή έχει ήδη λήξει.',
  },
  parent_stats: {
    title: 'Στατιστικά',
    week: 'Αυτή η Εβδομάδα',
    month: 'Αυτός ο Μήνας',
    year: 'Φέτος',
    days_logged: 'μέρες καταγραφής',
    food: 'Διατροφή',
    breakfast: 'Πρωινό',
    lunch: 'Μεσημεριανό',
    afternoon: 'Απογευματινό',
    days: 'μέρες',
    avg: 'μέσος όρος',
    per_day: 'μερίδες/μέρα',
    sleep: 'Ύπνος',
    naps: 'Μεσημεριανός ύπνος',
    absences: 'Απουσίες',
    full_absences: 'Ολοήμερες απουσίες',
    bus_only_absences: 'Χωρίς λεωφορείο',
    no_data: 'Δεν υπάρχουν δεδομένα για αυτή την περίοδο.',
    load_error: 'Αποτυχία φόρτωσης στατιστικών.',
  },
  parent_menu_page: {
    load_error: 'Αποτυχία φόρτωσης διατροφολογίου.',
    no_menu: 'Δεν υπάρχει διατροφολόγιο για αυτή την εβδομάδα.',
    breakfast: 'Πρωινό',
    lunch: 'Μεσημεριανό',
    afternoon: 'Απόγευμα',
    no_meal: 'Δεν έχει οριστεί',
  },
  parent_settings_page: {
    subtitle: 'Διαχείριση προφίλ και λογαριασμού',
    role_parent: 'Γονέας',
    allow_messages: 'Αποδοχή μηνυμάτων από γονείς',
    current_password: 'Τρέχων κωδικός',
    password_min_length: 'Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.',
    password_change_failed: 'Αποτυχία αλλαγής κωδικού',
    save_failed: 'Αποτυχία αποθήκευσης αλλαγών',
    danger_zone: 'Επικίνδυνη Ζώνη',
    danger_desc: 'Οριστική διαγραφή λογαριασμού. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    delete_account: 'Διαγραφή Λογαριασμού',
    delete_confirm: 'Εισάγετε τον κωδικό σας για να επιβεβαιώσετε τη διαγραφή.',
    password_placeholder: 'Κωδικός',
    delete_btn: 'Διαγραφή',
    account_deleted: 'Ο λογαριασμός διαγράφηκε. Αποσύνδεση...',
    delete_failed: 'Αποτυχία διαγραφής λογαριασμού',
    notifications_title: 'Ειδοποιήσεις',
    web_notifications: 'Ειδοποιήσεις προγράμματος περιήγησης',
    notifications_desc: 'Λάβετε ειδοποίηση όταν λαμβάνετε νέο μήνυμα.',
    notifications_active: 'Θα λαμβάνετε ειδοποιήσεις για νέα μηνύματα.',
    notifications_unblock_hint: 'Αποκλεισμένο από τον browser. Για επανενεργοποίηση, ανοίξτε τις ρυθμίσεις ιστότοπου και επιτρέψτε τις ειδοποιήσεις.',
    ios_push_hint: 'Για ενεργοποίηση ειδοποιήσεων στο iPhone, ανοίξτε την εφαρμογή από το εικονίδιο στην Αρχική Οθόνη και πατήστε "Ενεργοποίηση" στο μήνυμα που θα εμφανιστεί.',
    blocked: 'Αποκλεισμένο',
    mobile_notifications: 'Ειδοποιήσεις εφαρμογής κινητού',
    mobile_notifications_desc: 'Push ειδοποιήσεις στο τηλέφωνό σας μέσω της εφαρμογής γονέα.',
    notifications_enabled: 'Οι ειδοποιήσεις ενεργοποιήθηκαν!',
    notifications_denied: 'Η άδεια απορρίφθηκε. Επιτρέψτε τις ειδοποιήσεις στις ρυθμίσεις του προγράμματος περιήγησης.',
    notify_types_title: 'Να με ειδοποιείς όταν',
    notify_route_start: 'Ξεκινά ή τελειώνει η διαδρομή',
    notify_route_start_desc: 'Όταν το λεωφορείο αναχωρεί ή φτάνει στο σχολείο',
    notify_bus_near: 'Το λεωφορείο πλησιάζει',
    notify_bus_near_desc: 'Όταν το λεωφορείο είναι κοντά στη στάση σας',
    notify_bus_arriving: 'Το λεωφορείο φτάνει τώρα',
    notify_bus_arriving_desc: 'Όταν το λεωφορείο είναι λίγα μέτρα από τη στάση σας',
    notify_pick_drop: 'Παραλαβή / αποβίβαση παιδιού',
    notify_pick_drop_desc: 'Όταν το παιδί σας επιβιβάζεται ή αποβιβάζεται',
    notify_messages: 'Νέο μήνυμα από το σχολείο',
    notify_messages_desc: 'Όταν το σχολείο σας στέλνει μήνυμα',
    notify_delays: 'Καθυστερήσεις & έγκαιρες αφίξεις',
    notify_delays_desc: 'Όταν το λεωφορείο καθυστερεί ή φτάνει νωρίτερα',
  },
  push_prompt: {
    message: 'Ενεργοποιήστε τις ειδοποιήσεις για να λαμβάνετε ειδοποιήσεις για νέα μηνύματα.',
    enable: 'Ενεργοποίηση',
    ios_install: 'Για ειδοποιήσεις λεωφορείου στο iPhone, πατήστε το κουμπί Κοινοποίηση (↑) και επιλέξτε "Προσθήκη στην Αρχική", μετά ανοίξτε την εφαρμογή από εκεί.',
  },
  pwa_install: {
    message: 'Εγκαταστήστε αυτή την εφαρμογή στο τηλέφωνό σας για καλύτερη εμπειρία.',
    ios_message: 'Εγκατάσταση: πατήστε το κουμπί Κοινοποίηση και μετά "Προσθήκη στην Αρχική".',
    install: 'Εγκατάσταση',
    install_app: 'Προσθήκη στην Αρχική',
  },
  update_banner: {
    message: 'Υπάρχει διαθέσιμη νέα έκδοση.',
    refresh: 'Ανανέωση',
  },
  parent_help_page: {
    title: 'Βοήθεια',
    subtitle: 'Συχνές ερωτήσεις',
    go_to_settings: 'Μετάβαση στις Ρυθμίσεις',
    q_ios_notif: 'Πώς ενεργοποιώ τις ειδοποιήσεις στο iPhone / iPad;',
    ios_step1: 'Ανοίξτε αυτή τη σελίδα στο Safari.',
    ios_step2: 'Πατήστε το κουμπί Κοινοποίηση (το κουτί με το βέλος προς τα πάνω).',
    ios_step3: 'Κάντε κύλιση προς τα κάτω και πατήστε "Προσθήκη στην Αρχική Οθόνη".',
    ios_step4: 'Πατήστε "Προσθήκη" στην επάνω δεξιά γωνία.',
    ios_step5: 'Ανοίξτε την εφαρμογή από την Αρχική Οθόνη σας.',
    ios_step6: 'Μεταβείτε στις Ρυθμίσεις → Ειδοποιήσεις και ενεργοποιήστε τες.',
    ios_note: 'Οι web ειδοποιήσεις στο iPhone απαιτούν πρώτα εγκατάσταση στην Αρχική Οθόνη (iOS 16.4+).',
    q_android_notif: 'Πώς ενεργοποιώ τις ειδοποιήσεις στο Android;',
    android_step1: 'Πατήστε το μενού με τις τρεις τελείες (επάνω δεξιά).',
    android_step2: 'Πατήστε "Προσθήκη στην Αρχική Οθόνη" ή "Εγκατάσταση εφαρμογής".',
    android_step3: 'Ανοίξτε την εφαρμογή από την Αρχική Οθόνη σας.',
    android_step4: 'Μεταβείτε στις Ρυθμίσεις → Ειδοποιήσεις και ενεργοποιήστε τες.',
    q_desktop_notif: 'Πώς ενεργοποιώ τις ειδοποιήσεις στον υπολογιστή μου;',
    desktop_step1: 'Μεταβείτε στις Ρυθμίσεις → Ειδοποιήσεις.',
    desktop_step2: 'Ενεργοποιήστε την επιλογή "Ειδοποιήσεις browser".',
    desktop_step3: 'Επιτρέψτε τις ειδοποιήσεις όταν το browser σας ρωτήσει.',
    q_notif_preview: 'Οι ειδοποιήσεις δείχνουν μόνο σύντομη προεπισκόπηση — πώς να βλέπω πάντα το πλήρες μήνυμα;',
    notif_preview_intro: 'Ο πιο εύκολος τρόπος είναι να αλλάξετε τη ρύθμιση προεπισκόπησης ειδοποιήσεων στο τηλέφωνό σας, ώστε το πλήρες μήνυμα να εμφανίζεται πάντα.',
    ios_preview_title: 'iPhone',
    ios_preview_step1: 'Ανοίξτε την εφαρμογή Ρυθμίσεις του iPhone.',
    ios_preview_step2: 'Πηγαίνετε σε Ειδοποιήσεις → [Όνομα εφαρμογής].',
    ios_preview_step3: 'Πατήστε "Εμφάνιση Προεπισκοπήσεων" και επιλέξτε "Πάντα".',
    android_preview_title: 'Android',
    android_preview_step1: 'Ανοίξτε Ρυθμίσεις → Εφαρμογές → [Όνομα εφαρμογής].',
    android_preview_step2: 'Πατήστε Ειδοποιήσεις.',
    android_preview_step3: 'Ενεργοποιήστε "Εμφάνιση ευαίσθητου περιεχομένου" ή ορίστε προεπισκόπηση σε "Πάντα".',
    q_ios_expand: 'Πώς αναπτύσσω μια μεμονωμένη ειδοποίηση στο iPhone χωρίς να αλλάξω ρυθμίσεις;',
    ios_expand_step1: 'Πατήστε παρατεταμένα την ειδοποίηση στην οθόνη κλειδώματος.',
    ios_expand_step2: 'Πατήστε "Προβολή" για να δείτε το πλήρες κείμενο.',
    ios_expand_step3: 'Ή σύρετε αριστερά στην ειδοποίηση και πατήστε "Προβολή".',
    ios_expand_step4: 'Αν η ειδοποίηση έχει εξαφανιστεί, ανοίξτε την εφαρμογή και ελέγξτε την καρτέλα Μηνύματα.',
    q_android_expand: 'Πώς αναπτύσσω μια μεμονωμένη ειδοποίηση στο Android χωρίς να αλλάξω ρυθμίσεις;',
    android_expand_step1: 'Σύρετε το banner ειδοποίησης προς τα κάτω για να το αναπτύξετε.',
    android_expand_step2: 'Αν έχει ήδη απορριφθεί, τραβήξτε κάτω τη γραμμή ειδοποιήσεων.',
    android_expand_step3: 'Πατήστε την ειδοποίηση για να ανοίξετε την εφαρμογή και να διαβάσετε το πλήρες μήνυμα.',
  },
};

const savedLang = localStorage.getItem('sb_language') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      el: { translation: el },
    },
    lng: savedLang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
